/* eslint-disable jsx-a11y/accessible-emoji */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-sparse-arrays */
/* eslint-disable no-useless-concat */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from "react";
import styles from "./lbpNewLandingPage.module.css";
import VoiceService from "../../voice-agent/VH-Myra-FrontEnd";
import { AnalyticsService } from "../analytics/AnalyticsService";
import { useHistory, useLocation } from "react-router-dom";
import MyraChatService from "../../voice-agent/MyraChatService";
import { ajaxLink } from "../CONSTANTS";
import { useAssessment } from "../assessmentState";
import CareTeamIntake from "./Careteamintake";
import { CARE_TEAM_SUBMISSION, SAVE_ACCESS_DATA, SEND_ACCESS_MAIL, GET_ACCESS_DATA } from "../GSA_CONSTANTS";
import { buildLandingScreenPayload, persistLandingMessage } from "../utils/myraHelpers";

// ================= CONFIG =================
// const SERVED_STATES = ["DE", "DC", "MD", "NJ", "PA", "VA", "NC", "SC", "WV"];
const SERVED_STATES = ["DE", "DC", "MD", "NJ", "PA", "VA"];

const AREA_LABELS = { LBP: "lower back", HIP: "hip", THIGH: "thigh", KNEE: "knee" };
const AREA_ORDER = ["LBP", "HIP", "THIGH", "KNEE"];

// ===== REV 4: MEDICARE EXCLUSION LIST (Appendix F, Section D.1) =====
// Replaces the RED_FLAGS constant. All GSA safety items moved back to the GSA safety screen.
const EXCLUSION_WORDING_VERSION = "excl-2026-08-04-r4-draft";
const SWITCH_CONSENT_WORDING_VERSION = "switch-consent-2026-08-26-v1";
const SWITCH_CONSENT_WORDING = "I want to switch my Medicare ACCESS MSK participant to Virdio Health. I understand that switching is my choice and that Virdio will submit the switch to Medicare for approval.";

// ===== REV 5: STEP ORDER =====
// Step 1 State + Area  -> Step 2 Identity (Medicare details) -> [Step 6 waiting / CMS call]
// -> Step 3 Coverage -> Step 4 Exclusion list -> Step 5 Disclosure + consent
// -> Step 7 Outcome (the qualified outcome is held back until consent is given).
const ACCESS_STEP_ANALYTICS = {
  1: { screen: "access_state_area", viewedField: "access_state_area_viewed" },
  2: { screen: "access_identity", viewedField: "access_identity_viewed" },
  3: { screen: "access_coverage", viewedField: "access_coverage_viewed" },
  4: { screen: "access_exclusions", viewedField: "access_exclusions_viewed" },
  5: { screen: "access_preeligibility_disclosure", viewedField: "access_preeligibility_disclosure_viewed" },
  6: { screen: "access_eligibility_check", viewedField: "access_eligibility_check_started" },
  7: { screen: "access_outcome", viewedField: null },
  8: { screen: "access_care_team", viewedField: "access_care_team_viewed" },
};

// ===== REV 5: which CMS result codes mean "carry on with the rest of the flow" =====
// These are the codes where Medicare has said the person's coverage qualifies.
// The matching outcome screen is not shown immediately — it is held in
// pendingOutcomeKind and rendered once coverage, exclusions and consent are done.
const QUALIFYING_RESULT_CODES = ["eligible", "eligible-pending-diagnosis", "eligible-switch-participants"];
const isQualifyingResultCode = (code) => QUALIFYING_RESULT_CODES.includes(code);

const getExclusionItems = (area) => {
  const a = AREA_LABELS[area] || "affected area";
  const limb = area !== "LBP";
  return [
    { id: "injury", exit: "supervised", timeLimited: true, text: `My ${a} pain started after a fall, a direct hit, or another injury in the past 3 months` },
    { id: "surgery", exit: "supervised", timeLimited: true, text: `I have had surgery on my ${a} in the past 3 months` },
    { id: "recovering", exit: "supervised", timeLimited: true, text: `I am still recovering from a joint replacement or other major surgery in my ${a}` },
    { id: "fracture", exit: "supervised", timeLimited: true, text: `I have broken a bone in or near my ${a} in the past [X] months, or I have a break that has not fully healed` },
    { id: "osteoporosis", exit: "supervised", timeLimited: false, text: `A doctor has told me that I have severe osteoporosis, or that I am at high risk of breaking a bone` },
    { id: "weightbearing", exit: "supervised", timeLimited: false, text: limb ? `I am unable to put my full weight on that leg when I stand or walk` : `I am unable to stand or walk without help from another person` },
    { id: "pregnancy", exit: "pregnancy", timeLimited: true, text: `I am pregnant, or I have given birth in the past 6 months` },
    { id: "hospice", exit: "hospice", timeLimited: false, text: `I am receiving hospice care or palliative care` },
  ];
};

const STATES = [
  ["AL", "Alabama"],
  ["AK", "Alaska"],
  ["AZ", "Arizona"],
  ["AR", "Arkansas"],
  ["CA", "California"],
  ["CO", "Colorado"],
  ["CT", "Connecticut"],
  ["DE", "Delaware"],
  ["DC", "District of Columbia"],
  ["FL", "Florida"],
  ["GA", "Georgia"],
  ["HI", "Hawaii"],
  ["ID", "Idaho"],
  ["IL", "Illinois"],
  ["IN", "Indiana"],
  ["IA", "Iowa"],
  ["KS", "Kansas"],
  ["KY", "Kentucky"],
  ["LA", "Louisiana"],
  ["ME", "Maine"],
  ["MD", "Maryland"],
  ["MA", "Massachusetts"],
  ["MI", "Michigan"],
  ["MN", "Minnesota"],
  ["MS", "Mississippi"],
  ["MO", "Missouri"],
  ["MT", "Montana"],
  ["NE", "Nebraska"],
  ["NV", "Nevada"],
  ["NH", "New Hampshire"],
  ["NJ", "New Jersey"],
  ["NM", "New Mexico"],
  ["NY", "New York"],
  ["NC", "North Carolina"],
  ["ND", "North Dakota"],
  ["OH", "Ohio"],
  ["OK", "Oklahoma"],
  ["OR", "Oregon"],
  ["PA", "Pennsylvania"],
  ["RI", "Rhode Island"],
  ["SC", "South Carolina"],
  ["SD", "South Dakota"],
  ["TN", "Tennessee"],
  ["TX", "Texas"],
  ["UT", "Utah"],
  ["VT", "Vermont"],
  ["VA", "Virginia"],
  ["WA", "Washington"],
  ["WV", "West Virginia"],
  ["WI", "Wisconsin"],
  ["WY", "Wyoming"],
];

const stateName = (ab) => (STATES.find((s) => s[0] === ab) || [, ab])[1];

// MYRA Answers for the chat
const MYRA_ANSWERS = {
  "how does this work": "In short: you tell me which state you live in, answer a few short questions, and we check " + "with Medicare whether you qualify. If you do, I ask about your lower back, walk you through " + "one gentle movement, and build you a plan. That first part takes about fifteen minutes.",
  "what is the access model": "ACCESS is a Medicare program. The letters stand for Advancing Chronic Care with Effective, " + "Scalable Solutions. Medicare created it to pay for care that is delivered at home using " + "technology, and Virdio Health was accepted as one of the providers taking part.",
  "why do you need my medicare number": "Medicare is the one who decides whether you qualify, and it needs your Medicare number to " + "find you in its records. We use it only for that. We never ask for your Social Security " + "number, your bank details, or a payment of any kind.",
  "is this really free": "Yes. Medicare pays Virdio Health directly, and we cover the share you would normally owe. " + "There is no copay, no deductible, and no bill at the end. There is nothing to buy and " + "nothing to cancel.",
  "what happens next": "Once you finish these questions, we send your details to Medicare and wait for an answer. " + "It usually comes back in under a minute, and I will show it to you right here.",
  "can i start now": "Not quite yet. Medicare has to confirm you qualify before we can begin, and I am not able to " + 'start your assessment until that comes back. Use the "Check if I qualify" button, and ' + "if you qualify I will pick things up from there.",
};

const GENERAL_HOW_DOES_THIS_WORK_ANSWER = "In short: you tell me which state you live in, answer a few short questions, and we check " + "with Medicare whether you qualify. If you do, I ask about your problem area, walk you through " + "one gentle movement, and build you a plan. That first part takes about fifteen minutes.";

const myraLookup = (q) => {
  const key = q
    .toLowerCase()
    .replace(/[^a-z ]/g, "")
    .trim();
  let a = MYRA_ANSWERS[key];
  if (a) return a;
  if (/start|begin|sign up|join|enrol|enroll|assess/.test(key)) return MYRA_ANSWERS["can i start now"];
  if (/cost|free|pay|price|charge|bill/.test(key)) return MYRA_ANSWERS["is this really free"];
  if (/medicare number|mbi|card|social security|bank/.test(key)) return MYRA_ANSWERS["why do you need my medicare number"];
  if (/next|after|then|happen/.test(key)) return MYRA_ANSWERS["what happens next"];
  if (/how.*work|what.*do|steps/.test(key)) return MYRA_ANSWERS["how does this work"];
  if (/access|program|model|cms/.test(key)) return MYRA_ANSWERS["what is the access model"];
  return "That is a good question, and I want to give you an accurate answer rather than a guess. " + "For anything about your own Medicare records or coverage, Medicare is the right place to " + "ask — 1-800-MEDICARE, or 1-800-633-4227.";
};

// MBI Validation
const MBI_LETTERS = "ACDEFGHJKMNPQRTUVWXY";

const mbiPosOk = (ch, i) => {
  const isD = /[0-9]/.test(ch);
  const isL = MBI_LETTERS.includes(ch);
  if ([0, 3, 6, 9, 10].includes(i)) return isD;
  if ([1, 4, 7, 8].includes(i)) return isL;
  return isD || isL;
};

// ===== MYRA SEND MESSAGE — shared helpers for landing chat + steps chat =====

// ===== REV 4: Pre-screen Record Keeping =====
const prescreenRecord = (selectedArea, selectedState, screenAns, exclTicks, exclNone, exclAlone, exclusionItemsShown, exclusionItemsFired, aloneAsked, sessionId, startedAt, stoppedAt, outcome) => {
  const items = getExclusionItems(selectedArea);
  return {
    sessionId: sessionId || "sess-" + Math.random().toString(36).slice(2, 11),
    startedAt: startedAt || new Date().toISOString(),
    stoppedAt: stoppedAt || new Date().toISOString(),
    area: selectedArea || null,
    state: selectedState || null,
    coverageAnswers: { ...screenAns },
    exclusionItemsShown: exclusionItemsShown.length ? exclusionItemsShown : items.map((i) => i.id),
    exclusionItemsFired: exclusionItemsFired || [],
    aloneAnswer: exclAlone,
    aloneAsked: aloneAsked || exclTicks.size === 0,
    outcome: outcome,
    wordingVersion: EXCLUSION_WORDING_VERSION,
    submittedToCms: false,
  };
};

// ===== REV 4: Reliable pre-eligibility record write (Defect 8 fix) =====
// The record is the compliance artifact for Protocol 1 and, on the refusal
// routes, for Section 7.04. It must not be silently dropped by one failed
// request. This retries a few times before falling back to a client-side
// pending queue that is flushed on the next page load — the outcome screen
// is only treated as final after a confirmed write, or an honest attempt
// followed by queuing for retry.
const ACCESS_RECORD_RETRY_DELAYS_MS = [500, 1500, 3000];
const ACCESS_PENDING_RECORDS_KEY = "virdio_prescreen_records_pending";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const queuePendingAccessRecord = (record) => {
  try {
    const pending = JSON.parse(localStorage.getItem(ACCESS_PENDING_RECORDS_KEY) || "[]");
    pending.push(record);
    localStorage.setItem(ACCESS_PENDING_RECORDS_KEY, JSON.stringify(pending));
  } catch (e) {
    // non-fatal — the record still lives in virdio_prescreen_records
  }
};

const removePendingAccessRecord = (record) => {
  try {
    const pending = JSON.parse(localStorage.getItem(ACCESS_PENDING_RECORDS_KEY) || "[]");
    const next = pending.filter((r) => !(r.sessionId === record.sessionId && r.stoppedAt === record.stoppedAt));
    localStorage.setItem(ACCESS_PENDING_RECORDS_KEY, JSON.stringify(next));
  } catch (e) {
    // non-fatal
  }
};

// Posts a pre-eligibility record with retries. Resolves once the write has
// either been confirmed by the server or, after every attempt has failed,
// queued for a later flush. Never rejects and never leaves the record
// somewhere that only the beneficiary's own browser knows about.
const postAccessRecordWithRetry = async (record) => {
  for (let attempt = 0; attempt <= ACCESS_RECORD_RETRY_DELAYS_MS.length; attempt++) {
    try {
      const response = await fetch(SAVE_ACCESS_DATA, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(record),
      });
      if (response.ok) {
        const body = await response.json().catch(() => null);
        if (!body || body.success !== false) {
          removePendingAccessRecord(record);
          return true;
        }
      }
    } catch (error) {
      console.warn(`[ACCESS prescreen record] Save attempt ${attempt + 1} failed:`, error);
    }
    if (attempt < ACCESS_RECORD_RETRY_DELAYS_MS.length) {
      await sleep(ACCESS_RECORD_RETRY_DELAYS_MS[attempt]);
    }
  }
  // Every attempt failed — queue it rather than lose it. Flushed on next mount.
  queuePendingAccessRecord(record);
  return false;
};

// Retries any record left over from a previous session where every attempt
// failed (tab closed, connection down, etc). Called once on mount.
const flushPendingAccessRecords = async () => {
  let pending = [];
  try {
    pending = JSON.parse(localStorage.getItem(ACCESS_PENDING_RECORDS_KEY) || "[]");
  } catch (e) {
    pending = [];
  }
  for (const record of pending) {
    await postAccessRecordWithRetry(record);
  }
};

const LbpNewLandingPage = () => {
  // ===== STATE =====

  const { assessmentData, updateAssessmentData, resetAssessmentData } = useAssessment();
  const location = useLocation();
  const isGeneralAccessPage = location.pathname.replace(/\/+$/, "") === "/access";

  // Flow control
  const [flowOpen, setFlowOpen] = useState(false);
  const [step, setStep] = useState(1);
  const TOTAL = 5; // Step 1: Area+State, Step 2: Identity, Step 3: Coverage, Step 4: Exclusion List, Step 5: Disclosure

  // if came from subpages and then preselect area and state if present from the sub-pages
  const [lpStateChoice, setLpStateChoice] = useState(() => {
    try {
      if (new URLSearchParams(window.location.search).get("start") !== "1") return "";
      return JSON.parse(localStorage.getItem("virdio_lbp_preferences") || "{}").lpStateChoice || "";
    } catch (e) {
      return "";
    }
  });
  const [lpAreaChoice, setLpAreaChoice] = useState(() => {
    try {
      if (new URLSearchParams(window.location.search).get("start") !== "1") return "";
      return JSON.parse(localStorage.getItem("virdio_lbp_preferences") || "{}").lpAreaChoice || "";
    } catch (e) {
      return "";
    }
  });
  const [lpStateAck, setLpStateAck] = useState({ show: false, good: false, text: "" });

  // Step 1: Area + State
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedState, setSelectedState] = useState("");

  // Step 2: Pre-screen (Medicare Coverage)
  const [screenAns, setScreenAns] = useState({
    card: "",
    primary: "",
    services: "",
  });

  // Step 3: Medicare Exclusion List (Rev 4)
  // Step 3: Medicare Exclusion List (Rev 4)
  const [exclTicks, setExclTicks] = useState(new Set());
  const [exclNone, setExclNone] = useState(false);
  const [exclAlone, setExclAlone] = useState(null); // 'yes' or 'no' or null
  const [exclListMiss, setExclListMiss] = useState(false); // highlight: Q1 not answered
  const [exclAloneMiss, setExclAloneMiss] = useState(false); // highlight: Q2 (alone) not answered // 'yes' or 'no' or null

  // Session tracking for record keeping
  const [sessionId, setSessionId] = useState(window.trSessionId || localStorage.getItem("trSessionId") || null);
  const [startedAt, setStartedAt] = useState("");
  const [stoppedAt, setStoppedAt] = useState("");
  const [exclusionItemsShown, setExclusionItemsShown] = useState([]);
  const [exclusionItemsFired, setExclusionItemsFired] = useState([]);
  const [aloneAsked, setAloneAsked] = useState(false);

  // Step 4: Consent
  const [consentChecked, setConsentChecked] = useState(false);
  const [consentMiss, setConsentMiss] = useState(false); // highlight: consent box not ticked
  const [switchConsentEvidence, setSwitchConsentEvidence] = useState(null);

  // Step 5: Identity
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dobM, setDobM] = useState("");
  const [dobD, setDobD] = useState("");
  const [dobY, setDobY] = useState("");
  const [sex, setSex] = useState("");
  const [mbi, setMbi] = useState("");

  // ===== CMS Eligibility Response Fields =====
  const [submissionId, setSubmissionId] = useState("");
  const [submissionRecordId, setSubmissionRecordId] = useState("");
  const [eligibilityLinkToken, setEligibilityLinkToken] = useState("");
  const [showReturningModal, setShowReturningModal] = useState(false);
  const [returningRecord, setReturningRecord] = useState(null);

  // Save-and-return contact (saveBlock)
  const [saveContact, setSaveContact] = useState("");
  const [saveConfirmed, setSaveConfirmed] = useState(false);
  const saveContactRef = useRef("");
  saveContactRef.current = saveContact; // keep it always in sync with state
  const [saveBlockHighlight, setSaveBlockHighlight] = useState(false);

  // Errors
  const [areaErr, setAreaErr] = useState("");
  const [stateErr, setStateErr] = useState("");
  const [screenErr, setScreenErr] = useState("");
  const [consentErr, setConsentErr] = useState("");
  const [idErr, setIdErr] = useState("");
  const [isMbiInvalid, setIsMbiInvalid] = useState(false);

  // Outcome
  const [outcomeResult, setOutcomeResult] = useState("");
  // REV 5: the CMS result code returned by /access/eligibility when the person
  // qualifies. Held here while they complete coverage, exclusions and consent,
  // then rendered as the outcome screen once consent is given.
  const [pendingOutcomeKind, setPendingOutcomeKind] = useState("");

  // Myra chat (landing page)
  const [chatMessages, setChatMessages] = useState([{ who: "m", text: "Hello. I'm Myra. Ask me anything about this program and I'll explain it as plainly as I can." }]);
  const [chatInput, setChatInput] = useState("");
  const [landingTyping, setLandingTyping] = useState(false);

  // Myra flow (inside flow)
  const [myraMessages, setMyraMessages] = useState([]);
  const [myraInput, setMyraInput] = useState("");
  const [myraPanelOpen, setMyraPanelOpen] = useState(false);
  const [flowTyping, setFlowTyping] = useState(false);

  // Force result (prototype)
  const [forceResult, setForceResult] = useState("eligible");

  // Refs
  const chatLogRef = useRef(null);
  const myraLogRef = useRef(null);
  const mbiRef = useRef(null);
  const flowRef = useRef(null);
  const exclAloneRef = useRef(null);
  const saveBlockRef = useRef(null);
  const saveConfirmMsgRef = useRef(null);
  const screenQRefs = useRef({ card: null, primary: null, services: null });
  const prevAreaRef = useRef(selectedArea);

  // Myra send-message bookkeeping — landing chat and steps (flow) chat each
  // keep their own turn count + conversation_history, but call the same
  // MyraChatService.sendMessage under the hood.
  const landingTurnRef = useRef(0);
  const flowTurnRef = useRef(0);
  const landingApiHistoryRef = useRef([]);
  const flowApiHistoryRef = useRef([]);
  const activeAccessAnalyticsScreenRef = useRef(null);

  const getAnalyticsScreenFlow = () => window.screenTracker?.getScreenFlow?.() || [];
  const trackAccessAnalytics = (fields = {}) => {
    AnalyticsService.trackStep({
      is_access_user: true,
      ...fields,
      screenFlow: getAnalyticsScreenFlow(),
    });
  };
  const enterAccessAnalyticsScreen = (screenName, fields = {}) => {
    activeAccessAnalyticsScreenRef.current = screenName;
    window.screenTracker?.enterScreen?.(screenName);
    trackAccessAnalytics(fields);
  };
  const exitAccessAnalyticsScreen = (screenName, fields = {}, options = {}) => {
    window.screenTracker?.exitScreen?.(screenName, options);
    trackAccessAnalytics(fields);
  };
  const recordAccessAnalyticsEvent = (screenName, event, value = null) => {
    window.screenTracker?.recordEvent?.(screenName, event, value);
    trackAccessAnalytics();
  };

  // session id effect

  useEffect(() => {
    const previousSessionIdExits = window.trSessionId || localStorage.getItem("trSessionId");
    if (previousSessionIdExits) {
      localStorage.removeItem("trSessionId");
      resetAssessmentData();
      window.trSessionId = null;
      console.log("Existing session ID found and removed:", previousSessionIdExits);
    }
    if (window.__gsaLandingInitialized) {
      return;
    }
    window.__gsaLandingInitialized = true;
    // Defect 8 fix: retry any pre-eligibility record that failed to reach
    // the server on a previous visit (tab closed mid-retry, offline, etc).
    flushPendingAccessRecords();
    const enterTime = Date.now();
    const initializeSession = async () => {
      const analyticsSessionId = await AnalyticsService.startSession();
      if (!analyticsSessionId) return;
      setSessionId(analyticsSessionId);
      window.screenTracker?.reset?.();
      enterAccessAnalyticsScreen("access_landing", {
        access_landing_viewed: true,
      });
    };
    fetch("https://virdio.weborik.com/init.php")
      .then((response) => {
        if (!response.ok) throw new Error("IP Service Error");
        return response.json();
      })
      .then((data) => {
        window.backupIP = data.session;
      })
      .catch((error) => {
        console.warn("IP fetch blocked or failed (common in Incognito). Proceeding anyway.", error);
        window.backupIP = null;
      })
      .finally(() => {
        initializeSession();
        if (window.gtag) {
          console.log("Landing Page GTAG-TRIGGERS");
          //window.gtag("config", "AW-18002481001");
        }
      });
  }, []);

  // ===== EFFECTS =====

  // Load from localStorage on mount
  // Defect 3 fix: this used to read the `accessUserFromMail` STATE variable,
  // but that state is set by the separate effect above. Both effects are
  // the restore condition was always false and the
  // "save and return" link never actually restored anything. Reading the
  // URL param directly here removes the cross-effect race.
  useEffect(() => {
    //  do not pre select fields
    const params = new URLSearchParams(window.location.search);
    const cameFromAccessMail = params.get("accessUserFromMail") === "true";
    if (cameFromAccessMail && params.get("sessionId")) return;
    const saved = localStorage.getItem("virdio_lbp_preferences");
    if (saved && cameFromAccessMail) {
      try {
        const data = JSON.parse(saved);
        if (data.lpStateChoice) setLpStateChoice(data.lpStateChoice);
        if (data.lpAreaChoice) setLpAreaChoice(data.lpAreaChoice);
        if (data.selectedArea) setSelectedArea(data.selectedArea);
        if (data.selectedState) setSelectedState(data.selectedState);
        if (data.screenAns) setScreenAns(data.screenAns);
        // Step 3: Exclusion List
        if (data.exclTicks) setExclTicks(new Set(data.exclTicks));
        if (data.exclNone !== undefined) setExclNone(data.exclNone);
        if (data.exclAlone !== undefined) setExclAlone(data.exclAlone);
        // Record keeping
        // if (data.sessionId) setSessionId(data.sessionId);
        if (data.startedAt) setStartedAt(data.startedAt);
        if (data.stoppedAt) setStoppedAt(data.stoppedAt);
        if (data.exclusionItemsShown) setExclusionItemsShown(data.exclusionItemsShown);
        if (data.exclusionItemsFired) setExclusionItemsFired(data.exclusionItemsFired);
        if (data.aloneAsked !== undefined) setAloneAsked(data.aloneAsked);
        if (data.consentChecked !== undefined) setConsentChecked(data.consentChecked);
        if (data.switchConsentEvidence) setSwitchConsentEvidence(data.switchConsentEvidence);
        if (data.firstName) setFirstName(data.firstName);
        if (data.lastName) setLastName(data.lastName);
        if (data.dobM) setDobM(data.dobM);
        if (data.dobD) setDobD(data.dobD);
        if (data.dobY) setDobY(data.dobY);
        if (data.sex) setSex(data.sex);
        if (data.mbi) setMbi(data.mbi);
        if (data.saveContact) setSaveContact(data.saveContact);
        if (data.submissionId) setSubmissionId(data.submissionId);
        if (data.submissionRecordId) setSubmissionRecordId(data.submissionRecordId);
        if (data.eligibilityLinkToken) setEligibilityLinkToken(data.eligibilityLinkToken);
      } catch (e) {
        // ignore
      }
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const cameFromAccessMail = params.get("accessUserFromMail") === "true";
    const returningSessionId = params.get("sessionId");
    if (!cameFromAccessMail || !returningSessionId) return;

    let cancelled = false;
    fetch(`${GET_ACCESS_DATA}/${encodeURIComponent(returningSessionId)}`)
      .then((r) => r.json())
      .then((result) => {
        if (cancelled) return;
        if (result?.success && result.data) {
          setReturningRecord(result.data);
          setShowReturningModal(true);
        }
        // On failure or "no saved data found", fall through silently —
        // the person just sees the normal landing page.
      })
      .catch((err) => {
        console.warn("[ACCESS] Failed to load saved session data:", err);
      });

    return () => {
      cancelled = true;
    };
  }, []);
  // this effect will clear states on step 1
  useEffect(() => {
    // Only reset when the area changes AND we're on Step 1
    if (step === 1 && selectedArea !== prevAreaRef.current) {
      // Reset all flow state when area changes
      setScreenAns({ card: "", primary: "", services: "" });
      setExclTicks(new Set());
      setExclNone(false);
      setExclAlone(null);
      setAloneAsked(false);
      setExclListMiss(false);
      setExclAloneMiss(false);
      setScreenErr("");
      setAreaErr("");
      setStateErr("");

      prevAreaRef.current = selectedArea;
    }
  }, [step, selectedArea]);

  // Hydrate window.landing_chat from localStorage so buildLandingScreenPayload
  // has the full history even after a page refresh.
  useEffect(() => {
    if (!window.landing_chat) {
      try {
        const saved = localStorage.getItem("landing_chat");
        window.landing_chat = saved ? JSON.parse(saved) : [];
      } catch (e) {
        window.landing_chat = [];
      }
    }
    landingApiHistoryRef.current = window.landing_chat;
  }, []);

  // Save to localStorage whenever preferences change
  const savePreferences = useCallback(
    (saveContactOverride = saveContact) => {
      const data = {
        lpStateChoice,
        lpAreaChoice,
        selectedArea,
        selectedState,
        screenAns,
        // Step 3: Exclusion List (Rev 4)
        exclTicks: Array.from(exclTicks),
        exclNone,
        exclAlone,
        // Record keeping
        sessionId,
        startedAt,
        stoppedAt,
        exclusionItemsShown,
        exclusionItemsFired,
        aloneAsked,
        // Existing
        consentChecked,
        switchConsentAttestation: switchConsentEvidence?.decision === "granted",
        switchConsentEvidence,
        firstName,
        lastName,
        dobM,
        dobD,
        dobY,
        sex,
        mbi: mbi.replace(/[^0-9A-Z]/gi, "").toUpperCase(), // remove dashes
        saveContact: saveContactOverride,
        submissionId,
        submissionRecordId,
        eligibilityLinkToken,
      };
      localStorage.setItem("virdio_lbp_preferences", JSON.stringify(data));
    },
    [lpStateChoice, lpAreaChoice, selectedArea, selectedState, screenAns, exclTicks, exclNone, exclAlone, sessionId, startedAt, stoppedAt, exclusionItemsShown, exclusionItemsFired, aloneAsked, consentChecked, switchConsentEvidence, firstName, lastName, dobM, dobD, dobY, sex, mbi, saveContact, submissionId, submissionRecordId, eligibilityLinkToken],
  );

  useEffect(() => {
    savePreferences();
  }, [savePreferences]);

  // Scroll chat to bottom
  useEffect(() => {
    if (chatLogRef.current) {
      chatLogRef.current.scrollTop = chatLogRef.current.scrollHeight;
    }
  }, [chatMessages, landingTyping]);

  useEffect(() => {
    if (myraLogRef.current) {
      myraLogRef.current.scrollTop = myraLogRef.current.scrollHeight;
    }
  }, [myraMessages, flowTyping]);

  // ===== HANDLERS =====

  // Landing page state picker
  const handleLpStateChange = (e) => {
    const v = e.target.value;
    recordAccessAnalyticsEvent("access_landing", "state_selected", v === "__other" ? "other" : v);
    setLpStateChoice(v === "__other" ? "" : v);
    if (!v) {
      setLpStateAck({ show: false, good: false, text: "" });
    } else if (v === "__other") {
      setLpStateAck({
        show: true,
        good: false,
        text: "We are not there yet. We are adding states over time.",
      });
    } else {
      setLpStateAck({
        show: true,
        good: true,
        text: `Good news — we serve ${stateName(v)}. You can check if you qualify.`,
      });
    }
  };

  // Landing page area picker
  const handleLpAreaPick = (code) => {
    recordAccessAnalyticsEvent("access_landing", "area_selected", code);
    setLpAreaChoice((prev) => (prev === code ? "" : code));
  };

  // Area picker in flow (Step 1)
  const handleAreaPick = (code) => {
    recordAccessAnalyticsEvent("access_state_area", "area_selected", code);
    setSelectedArea(code);
    setAreaErr("");
  };

  // State picker in flow (Step 1)
  const handleStatePick = (value) => {
    recordAccessAnalyticsEvent("access_state_area", "state_selected", value);
    setSelectedState(value);
    setStateErr("");
  };

  // Pre-screen answer (Step 2)
  const handleAns = (q, val) => {
    recordAccessAnalyticsEvent("access_coverage", `${q}_selected`, val);
    setScreenAns((prev) => ({ ...prev, [q]: val }));
    // reset screen error once all fields are filled
    if ((q === "card" || screenAns.card) && (q === "primary" || screenAns.primary) && (q === "services" || screenAns.services)) {
      setScreenErr("");
    }
  };

  // ===== Step 3: Medicare Exclusion List Handlers =====

  // Toggle exclusion item
  const toggleExcl = (key) => {
    setScreenErr("");
    setExclListMiss(false);
    if (key === "none") {
      const nextNone = !exclNone;
      recordAccessAnalyticsEvent("access_exclusions", "exclusion_toggled", { key, selected: nextNone });
      setExclNone(nextNone);
      setExclTicks(new Set());
      if (exclNone) {
        // If unchecking "none", also clear alone answer
        setExclAlone(null);
        setAloneAsked(false);
      }
      return;
    }

    setExclNone(false);
    const newTicks = new Set(exclTicks);
    if (newTicks.has(key)) {
      newTicks.delete(key);
    } else {
      newTicks.add(key);
    }
    recordAccessAnalyticsEvent("access_exclusions", "exclusion_toggled", { key, selected: newTicks.has(key) });
    setExclTicks(newTicks);

    // If any tick is selected, hide the "alone" question
    if (newTicks.size > 0) {
      setAloneAsked(false);
      setExclAlone(null);
    }
  };

  // Answer the "alone" question
  const handleExclAlone = (val) => {
    recordAccessAnalyticsEvent("access_exclusions", "exercise_alone_selected", val);
    setExclAlone(val);
    setScreenErr("");
    setExclAloneMiss(false);
  };

  // Submit Step 3: Exclusion List
  const submitExcl = async () => {
    setScreenErr("");
    setExclListMiss(false);
    setExclAloneMiss(false);

    // Question 1: Must have ticks OR "none"
    if (exclTicks.size === 0 && !exclNone) {
      setExclListMiss(true);
      setScreenErr('Please answer the question above. If none of the situations apply to you, tick "None of these apply to me".');
      return;
    }

    // Question 2: If "none" is selected, must answer "yes" or "no"
    if (exclNone && exclAlone === null) {
      setExclAloneMiss(true);
      setScreenErr("Please answer the last question so we can finish checking.");
      exclAloneRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    // Get all items
    const items = getExclusionItems(selectedArea);
    const fired = items.filter((i) => exclTicks.has(i.id));
    const firedIds = fired.map((i) => i.id);

    // If "alone" is "no", add it to fired
    if (exclAlone === "no") firedIds.push("cannot-exercise-alone");

    window.screenTracker?.recordEvent?.("access_exclusions", "selected_items", firedIds.length ? firedIds : ["none"]);
    if (exclAlone !== null) {
      window.screenTracker?.recordEvent?.("access_exclusions", "exercise_alone", exclAlone);
    }

    // Set record keeping fields
    setExclusionItemsShown(items.map((i) => i.id));
    setExclusionItemsFired(firedIds);
    setAloneAsked(exclTicks.size === 0);
    const stoppedAtNow = new Date().toISOString();
    setStoppedAt(stoppedAtNow);

    // If nothing fired, proceed to consent (Step 5)
    if (firedIds.length === 0) {
      recordPass(stoppedAtNow);
      exitAccessAnalyticsScreen("access_exclusions", {
        access_exclusions_completed: true,
        access_exclusion_count: 0,
        access_prescreen_outcome: "passed-to-eligibility",
      });
      goTo(5);
      return;
    }

    // Determine exit: hospice > pregnancy > supervised
    let exit = "excl-supervised";
    if (fired.some((i) => i.exit === "hospice")) {
      exit = "excl-hospice";
    } else if (fired.some((i) => i.exit === "pregnancy")) {
      exit = "excl-pregnancy";
    }

    // Check if all fired items are time-limited and greater than 0
    const allTimeLimited = fired.length > 0 && fired.length === firedIds.filter((id) => id !== "cannot-exercise-alone").length && fired.every((i) => i.timeLimited);

    // Record the stop
    const record = prescreenRecord(selectedArea, selectedState, screenAns, exclTicks, exclNone, exclAlone, exclusionItemsShown, firedIds, aloneAsked, sessionId, startedAt, stoppedAtNow, exit);
    try {
      const existing = JSON.parse(localStorage.getItem("virdio_prescreen_records") || "[]");
      existing.push(record);
      localStorage.setItem("virdio_prescreen_records", JSON.stringify(existing));
    } catch (e) {
      // non-fatal
    }
    console.log("[ACCESS prescreen record]", record);
    // Defect 8 fix: this is the compliance record for a stop that has
    // already been shown to the beneficiary — it must not be fire-and-forget.
    // Retry, then queue for a later flush, before the outcome is final.
    postAccessRecordWithRetry(record);

    exitAccessAnalyticsScreen(
      "access_exclusions",
      {
        access_exclusions_completed: true,
        access_exclusion_count: firedIds.length,
        access_prescreen_outcome: exit,
      },
      { exitReason: exit },
    );
    renderOutcome(exit, { timeLimited: allTimeLimited });
    goTo(7); // Step 7 is Outcome
  };

  const recordPass = async (stoppedAtNow) => {
    const record = prescreenRecord(selectedArea, selectedState, screenAns, exclTicks, exclNone, exclAlone, exclusionItemsShown, [], aloneAsked, sessionId, startedAt, stoppedAtNow, "passed-to-eligibility");
    try {
      const existing = JSON.parse(localStorage.getItem("virdio_prescreen_records") || "[]");
      existing.push(record);
      localStorage.setItem("virdio_prescreen_records", JSON.stringify(existing));
    } catch (e) {
      // non-fatal
    }
    console.log("[ACCESS prescreen record]", record);
    // Defect 8 fix: same reliability guarantee as the stop path above.
    await postAccessRecordWithRetry(record);
  };

  // MBI input handler
  const handleMbiChange = (e) => {
    let raw = e.target.value
      .toUpperCase()
      .replace(/[^0-9A-Z]/g, "")
      .slice(0, 11);
    let out = raw;
    if (raw.length > 7) out = raw.slice(0, 4) + "-" + raw.slice(4, 7) + "-" + raw.slice(7);
    else if (raw.length > 4) out = raw.slice(0, 4) + "-" + raw.slice(4);
    setMbi(out);
    setIsMbiInvalid(false);
    setIdErr("");
  };

  // Same dash formatting as handleMbiChange, but for a value we already
  // have (from the saved record) rather than a keystroke event.
  const formatMbiDisplay = (raw) => {
    const clean = (raw || "")
      .toUpperCase()
      .replace(/[^0-9A-Z]/g, "")
      .slice(0, 11);
    if (clean.length > 7) return clean.slice(0, 4) + "-" + clean.slice(4, 7) + "-" + clean.slice(7);
    if (clean.length > 4) return clean.slice(0, 4) + "-" + clean.slice(4);
    return clean;
  };

  // Maps the access_user_data row (DB column names) onto this component's
  // state (frontend field names). Only sets what's actually present, same
  // convention as the localStorage restore effect below.
  const applyReturningRecord = (record) => {
    if (!record) return;
    if (record.sessionId) {
      setSessionId(record.sessionId);
      // sendToMyra reads window.trSessionId directly, not the sessionId
      // state — keep both in sync so Myra chat inside the flow works.
      window.trSessionId = record.sessionId;
      try {
        localStorage.setItem("trSessionId", record.sessionId);
      } catch (e) {
        // non-fatal
      }
    }
    if (record.area) setSelectedArea(record.area);
    if (record.state) setSelectedState(record.state);
    if (record.coverageAnswers) setScreenAns(record.coverageAnswers);
    if (record.exclusionItemsShown) setExclusionItemsShown(record.exclusionItemsShown);
    if (record.exclusionItemsFired) {
      setExclusionItemsFired(record.exclusionItemsFired);
      const ticks = record.exclusionItemsFired.filter((id) => id !== "cannot-exercise-alone");
      setExclTicks(new Set(ticks));
      setExclNone(ticks.length === 0 && record.exclusionItemsFired.length === 0);
    }
    if (record.aloneAnswer !== undefined && record.aloneAnswer !== null) setExclAlone(record.aloneAnswer);
    if (record.aloneAsked !== undefined && record.aloneAsked !== null) setAloneAsked(!!record.aloneAsked);
    if (record.startedAt) setStartedAt(record.startedAt);
    if (record.stoppedAt) setStoppedAt(record.stoppedAt);
    if (record.legalFirstName) setFirstName(record.legalFirstName);
    if (record.legalLastName) setLastName(record.legalLastName);
    if (record.dobMonth) setDobM(String(record.dobMonth));
    if (record.dobDay) setDobD(String(record.dobDay));
    if (record.dobYear) setDobY(String(record.dobYear));
    if (record.gender) setSex(record.gender);
    if (record.medicareNumber) setMbi(formatMbiDisplay(record.medicareNumber));
    if (record.saveContact) setSaveContact(record.saveContact);
    if (record.submissionId) setSubmissionId(record.submissionId);
    if (record.submissionRecordId) setSubmissionRecordId(record.submissionRecordId);
  };

  // ===== FLOW NAVIGATION =====

  const openFlow = () => {
    if (window.gtag) {
      console.log("GTAG-TRIGGERS FOR CLICKED VERIFY");
      window.gtag("event", "conversion", {
        send_to: "AW-18002481001/OqhhCIvD7O0cEOmeoIhD",
      });
    }

    recordAccessAnalyticsEvent("access_landing", "check_eligibility_clicked");
    exitAccessAnalyticsScreen("access_landing", {
      access_qualification_cta_clicked: true,
      access_flow_started: true,
    });
    setFlowOpen(true);
    document.body.style.overflow = "hidden";
    // Generate session ID and timestamp for record keeping
    // session-id is generated and provided by backend
    // setSessionId("sess-" + Math.random().toString(36).slice(2, 11));
    setStartedAt(new Date().toISOString());
    setStoppedAt("");
    setExclusionItemsFired([]);
    setExclusionItemsShown([]);
    setAloneAsked(false);
    setExclAlone(null);
    setExclTicks(new Set());
    setExclNone(false);
    setExclListMiss(false);
    setExclAloneMiss(false);
    setPendingOutcomeKind("");
    setOutcomeResult("");
    if (lpStateChoice) setSelectedState(lpStateChoice);
    if (lpAreaChoice) setSelectedArea(lpAreaChoice);
    goTo(1);
    window.scrollTo(0, 0);
  };

  // Consumes the ?start=1 param set by AccessSubPageShell.jsx's
  // ACCESS_LANDING_ROUTE, so a Google Ads sitelink (or subpage CTA) pointed
  // at /access/lbp?start=1 opens the eligibility flow immediately.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("start") === "1") {
      openFlow();
    }
  }, []);

  const resetFlowState = () => {
    setStep(1);
    setLpStateChoice("");
    setLpAreaChoice("");
    setLpStateAck({ show: false, good: false, text: "" });
    setSelectedArea("");
    setSelectedState("");
    setScreenAns({ card: "", primary: "", services: "" });
    setExclTicks(new Set());
    setExclNone(false);
    setExclAlone(null);
    setExclListMiss(false);
    setExclAloneMiss(false);
    setConsentChecked(false);
    setConsentMiss(false);
    setFirstName("");
    setLastName("");
    setDobM("");
    setDobD("");
    setDobY("");
    setSex("");
    setMbi("");
    setSaveContact("");
    setSaveConfirmed(false);
    saveContactRef.current = "";
    saveBlockRef.current?.classList.remove(styles.savepanelHighlight);
    saveConfirmMsgRef.current?.classList.remove(styles.show);
    setAreaErr("");
    setStateErr("");
    setScreenErr("");
    setConsentErr("");
    setIdErr("");
    setIsMbiInvalid(false);
    setOutcomeResult("");
    setPendingOutcomeKind("");
    setSubmissionId("");
    setSubmissionRecordId("");
    setEligibilityLinkToken("");
    localStorage.removeItem("virdio_lbp_preferences");
  };

  const closeFlow = () => {
    const activeAnalyticsScreen = activeAccessAnalyticsScreenRef.current;
    if (activeAnalyticsScreen) {
      exitAccessAnalyticsScreen(
        activeAnalyticsScreen,
        {},
        {
          completed: step === 7,
          exitReason: "closed",
        },
      );
    }
    setFlowOpen(false);
    setMyraPanelOpen(false);
    document.body.style.overflow = "";
    resetFlowState();
    enterAccessAnalyticsScreen("access_landing", { access_landing_viewed: true });
  };

  const goTo = (n, analyticsOverride = null) => {
    setStep(n);
    const analyticsStep = analyticsOverride || ACCESS_STEP_ANALYTICS[n];
    if (analyticsStep) {
      const viewedFields = analyticsStep.viewedField ? { [analyticsStep.viewedField]: true } : {};
      enterAccessAnalyticsScreen(analyticsStep.screen, viewedFields);
    }
    if (flowRef.current) flowRef.current.scrollTop = 0;
    window.scrollTo(0, 0);
  };

  // REV 4: Returning-from-email modal — "something changed" means we
  // don't trust the saved answers, so start over from Step 1. Keep the
  // sessionId so the eventual save upserts the same row instead of
  // creating a duplicate.
  const handleReturningYes = () => {
    setShowReturningModal(false);
    if (returningRecord?.sessionId) {
      setSessionId(returningRecord.sessionId);
      window.trSessionId = returningRecord.sessionId;
      try {
        localStorage.setItem("trSessionId", returningRecord.sessionId);
      } catch (e) {
        // non-fatal
      }
    }
    setStartedAt(new Date().toISOString());
    setStoppedAt("");
    setFlowOpen(true);
    document.body.style.overflow = "hidden";
    goTo(1);
    window.scrollTo(0, 0);
  };

  // "Nothing changed" — prefill everything from the saved record and drop them
  // at the identity screen (Step 2). REV 5: eligibility is now checked before
  // coverage, exclusions and consent, so the saved details are put back in front
  // of them ready to send rather than skipping straight past the Medicare call.
  const handleReturningNo = () => {
    setShowReturningModal(false);
    if (returningRecord && Object.keys(returningRecord).length > 0) {
      // We have data - prefill and go to the identity screen
      applyReturningRecord(returningRecord);
      setPendingOutcomeKind("");
      setOutcomeResult("");
      setFlowOpen(true);
      document.body.style.overflow = "hidden";
      goTo(2);
      window.scrollTo(0, 0);
    } else {
      // No data available - start fresh from step 1
      console.warn("[ACCESS] No returning record found, starting from step 1");
      setFlowOpen(true);
      document.body.style.overflow = "hidden";
      goTo(1);
      window.scrollTo(0, 0);
    }
  };

  // ===== STEP SUBMISSIONS =====

  // Step 1: State + Area
  const submitState = () => {
    setStateErr("");
    setAreaErr("");
    if (!selectedArea) {
      // setStateErr("Please choose the area that is bothering you.");
      // return;
      setAreaErr("Please choose the area that is bothering you.");
    }
    if (!selectedState) {
      // setStateErr("Please choose your state so we can check therapist licensing.");
      // return;
      setStateErr("Please choose your state so we can check therapist licensing.");
    }
    if (!selectedArea || !selectedState) return;
    window.screenTracker?.recordEvent?.("access_state_area", "area_selected", selectedArea);
    window.screenTracker?.recordEvent?.("access_state_area", "state_selected", selectedState);
    if (selectedState === "__other") {
      exitAccessAnalyticsScreen(
        "access_state_area",
        {
          access_state_area_completed: true,
          access_selected_area: selectedArea,
          access_selected_state: selectedState,
          access_prescreen_outcome: "state-not-served",
        },
        { exitReason: "state-not-served" },
      );
      renderOutcome("state-not-served", { state: "your state" });
      goTo(7);
      return;
    }
    exitAccessAnalyticsScreen("access_state_area", {
      access_state_area_completed: true,
      access_selected_area: selectedArea,
      access_selected_state: selectedState,
    });
    // Reset exclusion state — the exclusion list is answered later in the flow.
    setExclTicks(new Set());
    setExclNone(false);
    setExclAlone(null);
    setAloneAsked(false);
    setExclListMiss(false);
    setExclAloneMiss(false);
    // REV 5: Step 1 now hands off to the identity screen so Medicare can be
    // checked before we ask anything else.
    goTo(2);
  };

  // Step 2: Pre-screen (Medicare Coverage)
  const submitScreen = () => {
    setScreenErr("");
    const missing = [];
    if (!screenAns.card) missing.push("card");
    if (!screenAns.primary) missing.push("primary");
    if (!screenAns.services) missing.push("services");

    if (missing.length) {
      setScreenErr('Please answer all three questions. If you are unsure about any of them, choose "I\'m not sure" and we will check it with Medicare for you.');
      screenQRefs.current[missing[0]]?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    Object.entries(screenAns).forEach(([question, answer]) => {
      window.screenTracker?.recordEvent?.("access_coverage", `${question}_selected`, answer);
    });

    // Coverage stops
    if (screenAns.services === "yes") {
      exitAccessAnalyticsScreen(
        "access_coverage",
        {
          access_coverage_completed: true,
          access_prescreen_outcome: "prescreen-services",
        },
        { exitReason: "prescreen-services" },
      );
      renderOutcome("prescreen-services");
      goTo(7);
      return;
    }
    if (screenAns.card === "ma") {
      exitAccessAnalyticsScreen(
        "access_coverage",
        {
          access_coverage_completed: true,
          access_prescreen_outcome: "prescreen-ma",
        },
        { exitReason: "prescreen-ma" },
      );
      renderOutcome("prescreen-ma");
      goTo(7);
      return;
    }
    if (screenAns.primary === "yes") {
      exitAccessAnalyticsScreen(
        "access_coverage",
        {
          access_coverage_completed: true,
          access_prescreen_outcome: "prescreen-not-primary",
        },
        { exitReason: "prescreen-not-primary" },
      );
      renderOutcome("prescreen-not-primary");
      goTo(7);
      return;
    }

    // Move to Step 4 (Exclusion List)
    exitAccessAnalyticsScreen("access_coverage", {
      access_coverage_completed: true,
    });
    goTo(4);
  };

  // Step 5: Consent
  // REV 5: this is now the last screen before the outcome. Medicare has already
  // answered by this point, so ticking the box reveals the qualified outcome
  // that was held back in pendingOutcomeKind.
  const submitConsent = () => {
    setConsentErr("");
    setConsentMiss(false);
    if (!consentChecked) {
      setConsentMiss(true);
      setConsentErr("Please tick the box above so we know you have read this.");
      return;
    }
    window.screenTracker?.recordEvent?.("access_preeligibility_disclosure", "disclosure_accepted", true);
    exitAccessAnalyticsScreen("access_preeligibility_disclosure", {
      access_preeligibility_disclosure_completed: true,
    });

    const kind = pendingOutcomeKind || "eligible";
    window.screenTracker?.recordEvent?.("access_eligibility_result", "eligibility_result_revealed", kind);
    renderOutcome(kind);
    goTo(7, { screen: "access_eligibility_result", viewedField: "access_eligibility_result_viewed" });
  };

  // Step 2: Identity
  const submitIdentity = async () => {
    setIdErr("");
    setIsMbiInvalid(false);
    const raw = mbi.replace(/[^0-9A-Z]/gi, "").toUpperCase();
    const identityErrors = [];

    if (!firstName) {
      // setIdErr("Please enter your legal first name as it appears on your Medicare card.");
      // return;
      identityErrors.push("Please enter your legal first name as it appears on your Medicare card.");
    }
    if (!lastName) {
      // setIdErr("Please enter your legal last name as it appears on your Medicare card.");
      // return;
      identityErrors.push("Please enter your legal last name as it appears on your Medicare card.");
    }
    if (!dobM || !dobD || !dobY) {
      // setIdErr("Please enter your full date of birth.");
      // return;
      identityErrors.push("Please enter your full date of birth.");
    }
    if (!sex) {
      // setIdErr("Please choose an option so we can match Medicare's records.");
      // return;
      identityErrors.push("Please choose an option so we can match Medicare's records.");
    }
    if (raw.length !== 11) {
      // setIdErr("Your Medicare number should be 11 characters. You have entered " + raw.length + ". Check the front of your red, white and blue card — the dashes do not count.");
      // return;
      setIsMbiInvalid(true);
      identityErrors.push("Your Medicare number should be 11 characters. You have entered " + raw.length + ". Check the front of your red, white and blue card — the dashes do not count.");
    } else {
      for (let i = 0; i < 11; i++) {
        if (!mbiPosOk(raw[i], i)) {
          const pos = i + 1;
          let why;
          if ([0, 3, 6, 9, 10].includes(i)) why = "Character " + pos + " should be a number.";
          else if ([1, 4, 7, 8].includes(i)) why = "Character " + pos + " should be a letter.";
          else why = "Character " + pos + " is not one Medicare uses.";
          // setIdErr(why + " Medicare numbers never use the letters S, L, O, I, B or Z — " + "it is easy to mistake a letter O for a zero. Please check that character again.");
          // return;
          setIsMbiInvalid(true);
          identityErrors.push(why + " Medicare numbers never use the letters S, L, O, I, B or Z — " + "it is easy to mistake a letter O for a zero. Please check that character again.");
          break;
        }
      }
    }
    if (identityErrors.length) {
      setIdErr(identityErrors.join("\n"));
      return;
    }

    window.screenTracker?.recordEvent?.("access_identity", "identity_form_completed", true);
    exitAccessAnalyticsScreen("access_identity", {
      access_identity_completed: true,
    });
    goTo(6);

    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const variant = new URLSearchParams(window.location.search).get("variant") || localStorage.getItem("variant") || null;
      if (variant) localStorage.setItem("variant", variant);

      const eligibilityResponse = await fetch(`${ajaxLink}/access/eligibility`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          insuranceCode: raw,
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          birthDate: `${dobY}-${String(dobM).padStart(2, "0")}-${String(dobD).padStart(2, "0")}`,
          gender: sex,
          track: "MSK",
          variant,
        }),
      });

      const rawResponse = await eligibilityResponse.text();
      let responseBody = null;
      try {
        responseBody = rawResponse ? JSON.parse(rawResponse) : null;
      } catch (error) {
        throw new Error(rawResponse || "Medicare eligibility returned an invalid response. Please try again.");
      }
      const responseData = responseBody?.responseData || responseBody;
      const submissionIdFromApi = responseData?.submissionId || null;
      const submissionRecordIdFromApi = responseData?.submissionRecordId || null;
      const eligibilityLinkTokenFromApi = responseData?.eligibilityLinkToken || null;
      setSubmissionId(submissionIdFromApi);
      setSubmissionRecordId(submissionRecordIdFromApi);
      setEligibilityLinkToken(eligibilityLinkTokenFromApi);
      if (sessionId && submissionIdFromApi) {
        fetch(CARE_TEAM_SUBMISSION, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ sessionId, submissionId: submissionIdFromApi, submissionRecordId: submissionRecordIdFromApi, firstName, lastName }),
        }).catch((err) => console.warn("[ACCESS] care-team submission failed (non-blocking):", err));
      }
      const eligibilityResult = responseBody?.responseData || responseBody;
      const resultCode = eligibilityResult?.code || eligibilityResult?.resultAction?.code;

      if (!eligibilityResponse.ok || !resultCode) {
        throw new Error(responseBody?.errorData?.message || responseBody?.responseMessage || "Medicare eligibility could not be checked. Please try again.");
      }

      window.screenTracker?.recordEvent?.("access_eligibility_check", "eligibility_result", resultCode);
      exitAccessAnalyticsScreen("access_eligibility_check", {
        access_eligibility_check_completed: true,
        access_eligibility_result_code: resultCode,
      });

      // REV 5: Medicare says the coverage qualifies — hold the outcome screen
      // back and carry on with coverage, exclusions and consent. The outcome is
      // rendered by submitConsent once the disclosure has been accepted.
      if (isQualifyingResultCode(resultCode)) {
        setPendingOutcomeKind(resultCode);
        setOutcomeResult("");
        goTo(3);
        return;
      }

      // Every other code is a stop — show it straight away, exactly as before.
      setPendingOutcomeKind("");
      renderOutcome(resultCode);
      goTo(7, { screen: "access_eligibility_result", viewedField: "access_eligibility_result_viewed" });
    } catch (error) {
      console.error("[ACCESS eligibility] Check failed:", error);
      exitAccessAnalyticsScreen(
        "access_eligibility_check",
        {
          access_eligibility_error_code: "request_failed",
        },
        { completed: false, exitReason: "request_failed" },
      );
      setPendingOutcomeKind("");
      // Back to the identity screen (now Step 2) with the details still filled in.
      goTo(2);
      setIdErr(error.message || "Medicare eligibility could not be checked. Please try again.");
    }
  };

  // ===== MYRA CHAT =====

  const addChatMessage = (who, text) => {
    setChatMessages((prev) => [...prev, { who, text }]);
  };

  // Myra flow
  const addMyraMessage = (who, text) => {
    setMyraMessages((prev) => [...prev, { who, text }]);
  };

  // Shared by the landing-page widget and the steps (in-flow) widget.
  // isLanding controls whether the turn is also mirrored into
  // window.landing_chat / localStorage so later screens (and later Myra
  // calls, per buildLandingScreenPayload) can see what was asked on landing.
  const sendToMyra = async ({ text, screenName, addMessage, historyRef, turnRef, isLanding, setTyping }) => {
    const trimmed = text.trim();
    if (!trimmed) return;
    const normalizedQuestion = trimmed
      .toLowerCase()
      .replace(/[^a-z ]/g, "")
      .trim();
    const generalCannedResponse = isLanding && isGeneralAccessPage && normalizedQuestion === "how does this work" ? GENERAL_HOW_DOES_THIS_WORK_ANSWER : null;

    addMessage("u", trimmed);
    if (isLanding) persistLandingMessage("user", trimmed);
    historyRef.current = [...historyRef.current, { role: "user", content: trimmed }];

    const screenPayload = buildLandingScreenPayload(screenName);
    const sessionId = window.trSessionId || "";
    turnRef.current += 1;

    setTyping(true);
    try {
      const result = await MyraChatService.sendMessage(trimmed, sessionId, historyRef.current, turnRef.current, screenPayload, screenName);

      const responseText = generalCannedResponse || result.response;
      addMessage("m", responseText);
      if (isLanding) persistLandingMessage("assistant", responseText);
      if (result.history && result.history.length) {
        if (generalCannedResponse && result.history[result.history.length - 1]?.role === "assistant") {
          historyRef.current = [...result.history.slice(0, -1), { ...result.history[result.history.length - 1], content: responseText }];
        } else {
          historyRef.current = result.history;
        }
      } else {
        historyRef.current = [...historyRef.current, { role: "assistant", content: responseText }];
      }
    } finally {
      setTyping(false);
    }
  };

  const sendChat = () => {
    const v = chatInput;
    if (!v.trim()) return;
    setChatInput("");
    sendToMyra({ text: v, screenName: "intro", addMessage: addChatMessage, historyRef: landingApiHistoryRef, turnRef: landingTurnRef, isLanding: true, setTyping: setLandingTyping });
  };

  const askMyra = (q) => {
    sendToMyra({ text: q, screenName: "intro", addMessage: addChatMessage, historyRef: landingApiHistoryRef, turnRef: landingTurnRef, isLanding: true, setTyping: setLandingTyping });
  };

  const sendMyraFlow = () => {
    const v = myraInput;
    if (!v.trim()) return;
    setMyraInput("");
    setMyraPanelOpen(true);
    sendToMyra({ text: v, screenName: `lbp_step_${step}`, addMessage: addMyraMessage, historyRef: flowApiHistoryRef, turnRef: flowTurnRef, isLanding: false, setTyping: setFlowTyping });
  };

  const askMyraFlow = (q) => {
    setMyraPanelOpen(true);
    sendToMyra({ text: q, screenName: `lbp_step_${step}`, addMessage: addMyraMessage, historyRef: flowApiHistoryRef, turnRef: flowTurnRef, isLanding: false, setTyping: setFlowTyping });
  };

  // ===== OUTCOMES =====

  const areaLabel = () => AREA_LABELS[selectedArea] || "muscle and joint";

  const handleStartSelfPay = () => {
    setFlowOpen(false);
    setStep(1);
    setLpStateChoice("");
    setLpAreaChoice("");
    setLpStateAck({ show: false, good: false, text: "" });
    setSelectedArea("");
    setSelectedState("");
    setScreenAns({ card: "", primary: "", services: "" });
    setExclTicks(new Set());
    setExclNone(false);
    setExclAlone(null);
    setConsentChecked(false);
    setConsentMiss(false);
    setFirstName("");
    setLastName("");
    setDobM("");
    setDobD("");
    setDobY("");
    setSex("");
    setMbi("");
    setSaveContact("");
    setSaveConfirmed(false);
    saveContactRef.current = "";
    saveBlockRef.current?.classList.remove(styles.savepanelHighlight);
    saveConfirmMsgRef.current?.classList.remove(styles.show);
    setSaveBlockHighlight(false);
    setAreaErr("");
    setStateErr("");
    setScreenErr("");
    setConsentErr("");
    setIdErr("");
    setIsMbiInvalid(false);
    setOutcomeResult("");
    setPendingOutcomeKind("");
    setSubmissionId("");
    setSubmissionRecordId("");
    setEligibilityLinkToken("");
    localStorage.removeItem("virdio_lbp_preferences");
    history.replace("/", { completedFlowData: { ...getCompletedFlowData(forceResult), isAccessUser: false } });
  };

  const selfPayBlock = (notshow = false) => (
    <div className={styles.outcomeBody}>
      <h3>You can still work with Myra</h3>
      <p>You do not qualify for the Medicare program, but the recovery program itself is still open to you. Myra can build you the same kind of plan for your {areaLabel()}.</p>
      <ul className={styles.outcomeList}>
        <li>✓ The assessment is free.</li>
        <li>✓ Your first plan is free, and it is yours to keep.</li>
        <li>✓ Your first session is free.</li>
      </ul>
      <p>If you want to keep going after that first session, there is a cost. If you decide not to, you keep your plan and there is nothing to cancel.</p>
      {!notshow && (
        <div className={styles.actions}>
          <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={handleStartSelfPay}>
            You can start self Paying process.
          </button>
        </div>
      )}
    </div>
  );

  const clinicianBlock = () => (
    <div className={styles.outcomeBody}>
      <h3>What to do instead</h3>
      <p>We are not going to offer you an exercise program to follow on your own. With what you have told us, the right person to guide any movement or activity is a clinician who knows your full medical situation.</p>
      <p>Please talk to your doctor or your care team. They can advise what is safe for you and arrange it in a way that is properly supervised.</p>
    </div>
  );

  // REV 4 — exit block for the Medicare exclusion list (Step 3)
  const referralBlock = () => (
    <div className={styles.outcomeBody}>
      <h3>What to do instead</h3>
      <p>Ask your doctor for a referral to physical therapy you attend in person, or where a therapist supervises you directly. That is the right kind of care for where you are at the moment, and it is covered by Medicare in the usual way.</p>
      <p>If you are not sure who to ask, your doctor's office is the place to start.</p>
      <div className={styles.actions}>
        <button className={`${styles.btn} ${styles.btnGhost}`} onClick={closeFlow}>
          Close
        </button>
      </div>
    </div>
  );

  const scrollToSaveBlock = () => {
    const el = saveBlockRef.current;
    if (el) {
      el.classList.add(styles.savepanelHighlight);
      el.querySelector("input")?.focus();
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const saveBlock = (kind = forceResult) => (
    <div ref={saveBlockRef} className={styles.savepanel}>
      <h3>We can save your answers</h3>
      <p>Tell us where to reach you and we will hold everything you have entered so far. Next time you come back you will pick up where you left off instead of starting again.</p>
      <div className={styles.saverow}>
        <input
          type="text"
          className={styles.input}
          placeholder="Email address or mobile number"
          defaultValue={saveContact}
          onChange={(e) => {
            saveContactRef.current = e.target.value;
            setSaveContact(e.target.value);
            setSaveConfirmed(false);
          }}
        />
        <button
          className={`${styles.btn} ${styles.btnPrimary}`}
          onClick={async () => {
            const currentSaveContact = saveContactRef.current.trim();
            if (!currentSaveContact) return;
            savePreferences(currentSaveContact);
            try {
              const currentSessionId = sessionId || window.trSessionId;
              let storedData = {};
              try {
                const saved = localStorage.getItem("virdio_lbp_preferences");
                if (saved) storedData = JSON.parse(saved);
              } catch (e) {
                storedData = {};
              }
              const accessData = buildAccessDataPayload({
                ...storedData,
                sessionId: currentSessionId,
                saveContact: currentSaveContact,
                outcomeType: kind,
                wordingVersion: EXCLUSION_WORDING_VERSION,
                submittedToCms: false,
              });
              const response = await fetch(SEND_ACCESS_MAIL, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  sessionId: currentSessionId,
                  saveContact: currentSaveContact,
                  accessData,
                }),
              });

              const result = await response.json();

              if (result.success) {
                console.log("[AccessData] Contact saved successfully:", result);
              } else {
                console.error("[AccessData] Failed to save contact:", result.message);
              }
            } catch (error) {
              console.error("[AccessData] API error:", error);
            }
            setSaveConfirmed(true);
            saveConfirmMsgRef.current?.classList.add(styles.show);
          }}
        >
          Save my answers
        </button>
      </div>
      <div ref={saveConfirmMsgRef} className={styles.saveConfirmMsg}>
        ✓ Saved.
      </div>
    </div>
  );

  const medicareTail = () => (
    <div className={styles.helpline}>
      Questions about your Medicare records or coverage? Call <strong>1-800-MEDICARE</strong> (1-800-633-4227). TTY <strong>1-877-486-2048</strong>.
    </div>
  );

  const startAccessGsa = (kind, extraCompletedFlowData = {}) => {
    window.screenTracker?.recordEvent?.("access_eligibility_result", "start_with_myra_clicked", kind);
    exitAccessAnalyticsScreen("access_eligibility_result", {
      access_started_gsa: true,
      access_eligibility_result_code: kind,
    });
    window.__gsaLandingInitialized = false;
    history.replace("/", { completedFlowData: { ...getCompletedFlowData(kind), ...extraCompletedFlowData } });
  };

  const startSelfPayGsa = (kind) => {
    window.__gsaLandingInitialized = false;
    history.replace("/", { completedFlowData: { ...getCompletedFlowData(kind), isAccessUser: false } });
  };

  const renderOutcome = (kind, data) => {
    data = data || {};

    if ((kind === "eligible" || kind === "eligible-pending-diagnosis") && window.gtag) {
      console.log("GTAG-TRIGGERS FOR ELIGIBLE");
      window.gtag("event", "conversion", {
        send_to: "AW-18002481001/wKn2CK3X7-0cEOmeoIhD",
      });
    }

    let html = null;

    switch (kind) {
      case "state-not-served":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.stop}`}>!</div>
              <div>
                <h2>We are not in your state yet.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>This Medicare program requires a physical therapist licensed in your state, and we do not have one there at the moment. We are adding states over time.</p>
              <p>Nothing you entered has been sent anywhere, and we have not asked for your Medicare number.</p>
            </div>
            <div className={styles.actions}>
              <button onClick={scrollToSaveBlock} className={`${styles.btn} ${styles.btnOutline}`}>
                Tell me when you reach my state
              </button>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={closeFlow}>
                Close
              </button>
            </div>
            {saveBlock(kind)}
          </>
        );
        break;

      // ===== REV 4: Exclusion List Outcomes =====
      case "excl-supervised":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.stop}`}>!</div>
              <div>
                <h2>This program is not the right fit right now.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>Medicare's rules for the ACCESS program mean you cannot take part right now because one of the situations you selected is on Medicare's exclusion list. That is a rule about the program, not a judgement about you.</p>
              <p>Separately, we are not going to offer you an exercise program to follow on your own. The right person to guide any movement or activity at the moment is a physical therapist or clinician who can see you and knows your full medical situation.</p>
              <p>We have not asked for, and do not have, your Medicare number, and nothing has been sent to Medicare.</p>
              {data.timeLimited && <p>Some of Medicare's rules are about the last few months. If that is the case for you, you are welcome to come back and check again once more time has passed.</p>}
            </div>
            {referralBlock()}
          </>
        );
        break;

      case "excl-pregnancy":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.stop}`}>!</div>
              <div>
                <h2>This program is not available during pregnancy, or in the first six months after birth.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>Medicare's rules for the ACCESS program mean you cannot take part during pregnancy or in the first six months after giving birth. That is a rule about the program, not a judgement about you.</p>
              <p>Separately, we are not going to offer you an exercise program to follow on your own while this applies. Your doctor or midwife is the right person to advise what movement is right for you now, and can refer you to a physical therapist if that would help.</p>
              <p>We have not asked for, and do not have, your Medicare number, and nothing has been sent to Medicare.</p>
              {data.timeLimited && <p>Some of Medicare's rules are about the last few months. If that is the case for you, you are welcome to come back and check again once more time has passed.</p>}
            </div>
            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={closeFlow}>
                Close
              </button>
            </div>
          </>
        );
        break;

      case "excl-hospice":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.stop}`}>!</div>
              <div>
                <h2>This program is not available alongside hospice or palliative care.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>Medicare's rules for the ACCESS program mean you cannot take part while you are receiving hospice or palliative care. That is a rule about the program, not a judgement about you.</p>
              <p>Separately, we are not going to offer you an exercise program to follow on your own. If pain or difficulty moving is troubling you, your care team is the right place to raise it. They can arrange support that fits alongside the care you are already receiving.</p>
              <p>We have not asked for, and do not have, your Medicare number, and nothing has been sent to Medicare.</p>
            </div>
            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={closeFlow}>
                Close
              </button>
            </div>
            {medicareTail()}
          </>
        );
        break;

      case "prescreen-not-medicare":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.stop}`}>!</div>
              <div>
                <h2>This program needs Original Medicare Part A and Part B.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>Medicare only allows people with both Part A and Part B to take part in the ACCESS program. Based on your answer, that is not you right now.</p>
              <p>We have not asked for, and do not have, your Medicare number.</p>
            </div>
            {selfPayBlock()}
            {medicareTail()}
          </>
        );
        break;

      case "prescreen-ma":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.stop}`}>!</div>
              <div>
                <h2>Medicare Advantage plans are not part of this program.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>Medicare is testing this program with Original Medicare only. If your card comes from a private plan, you are in Medicare Advantage and are not eligible — that is Medicare's rule, not ours.</p>
              <p>Your plan may cover physical therapy another way. It is worth calling the number on your plan card to ask.</p>
              <p>We have not asked for, and do not have, your Medicare number.</p>
            </div>
            {selfPayBlock()}
            {medicareTail()}
          </>
        );
        break;

      case "prescreen-not-primary":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.stop}`}>!</div>
              <div>
                <h2>Medicare needs to be your primary insurance.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>This program requires Medicare to be the insurance that pays first. Based on your answer, something else pays before Medicare does.</p>
              <p>If you are not certain about this, Medicare can tell you which insurance pays first. It is a common thing to be unsure about, and it is worth getting right.</p>
            </div>
            {selfPayBlock()}
            {medicareTail()}
          </>
        );
        break;

      case "prescreen-services":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.stop}`}>!</div>
              <div>
                <h2>This program is not available alongside that care.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>Medicare does not allow people receiving dialysis for kidney failure, or care through a PACE program, to take part in ACCESS.</p>
              <p>We have not asked for, and do not have, your Medicare number.</p>
            </div>
            {clinicianBlock()}
            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={closeFlow}>
                Close
              </button>
            </div>
            {medicareTail()}
          </>
        );
        break;

      case "eligible":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.good}`}>✓</div>
              <div>
                <h2>Good news — you qualify.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>Medicare has confirmed you are eligible for the ACCESS program with Virdio Health. There is no cost to you.</p>
              <p>Next comes your assessment. Myra will ask you about your {areaLabel()} and walk you through one gentle movement. It takes about 15 minutes and you do not need a camera.</p>
            </div>
            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={() => startAccessGsa(kind)}>
                Start with Myra
              </button>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={scrollToSaveBlock}>
                I'll come back later
              </button>
            </div>
            {saveBlock(kind)}
          </>
        );
        break;

      case "eligible-pending-diagnosis":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.good}`}>✓</div>
              <div>
                <h2>You qualify — one thing still to confirm.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>Medicare has confirmed your coverage qualifies. The last thing Medicare needs is the specific condition being treated, which comes out of your session with Myra.</p>
              <p>Nothing more is needed from you now. Let's get started.</p>
            </div>
            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={() => startAccessGsa(kind)}>
                Start with Myra
              </button>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={scrollToSaveBlock}>
                I'll come back later
              </button>
            </div>
            {saveBlock(kind)}
          </>
        );
        break;

      case "eligible-switch-participants":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.warn}`}>→</div>
              <div>
                <h2>You are currently signed up with another provider.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>Medicare's records show you are already in the ACCESS program with a different organization. You are free to move to Virdio Health if you want to — it is entirely your choice, and you can also stay where you are.</p>
              <p>If you want to move, Medicare requires us to record your agreement separately before we can do that.</p>
              <p>{SWITCH_CONSENT_WORDING}</p>
            </div>
            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={handleSwitchParticipantConsent}>
                I want to move to Virdio Health
              </button>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={closeFlow}>
                I'll stay where I am
              </button>
            </div>
          </>
        );
        break;

      case "not-eligible-mismatch":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.warn}`}>?</div>
              <div>
                <h2>Those details did not match Medicare's records.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>This usually means a small typing difference, not a problem with your coverage. The most common causes are:</p>
              <ul className={styles.outcomeList}>
                <li>A name that differs from the card — for example "Bill" instead of "William"</li>
                <li>The number 0 typed where the letter O appears, or the other way round</li>
                <li>A date of birth that is off by a digit</li>
                <li>A sex that does not match what Medicare has on record</li>
              </ul>
              <p>Please check and try again. You can try as many times as you need.</p>
            </div>
            <div className={styles.actions}>
              <button
                className={`${styles.btn} ${styles.btnPrimary}`}
                onClick={() => {
                  setIdErr("");
                  setIsMbiInvalid(false);
                  goTo(2);
                }}
              >
                Check my details and try again
              </button>
              <button onClick={scrollToSaveBlock} className={`${styles.btn} ${styles.btnGhost}`}>
                Leave for now
              </button>
            </div>
            {saveBlock(kind)}
            {medicareTail()}
          </>
        );
        break;

      case "not-eligible-control-group":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.warn}`}>!</div>
              <div>
                <h2>You are not eligible to enroll.</h2>
              </div>
            </div>
            <div className={styles.cmsVerbatim}>
              <div className={styles.tagline}>Required Medicare notice — CMS wording, may not be modified</div>
              <p>
                These services are part of a federal payment model test being conducted by the Centers for Medicare &amp; Medicaid Services (CMS). To evaluate the model, some individuals are assigned to a comparison group and are not eligible to enroll for 12 months. This is a random assignment made by CMS for evaluation purposes only and is not based on anything about you or your health. You may continue to receive other services as usual and your Medicare coverage, benefits, and rights are not affected in any way. If you have questions, you may call <span className={styles.phonebig}>1-800-MEDICARE</span> (1-800-633-4227). Teletypewriter (TTY) users call <span className={styles.phonebig}>1-877-486-2048</span>.
              </p>
            </div>
            <div className={styles.outcomeBody}>
              <p>We know that is a disappointing answer to get, and it is not one we or Medicare chose for any reason to do with you. Everything below is a separate Virdio Health program. It is not part of Medicare or the ACCESS Model.</p>
            </div>
            {selfPayBlock(true)}
            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={() => startSelfPayGsa(kind)}>
                Show me how that works
              </button>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={closeFlow}>
                No thanks
              </button>
            </div>
            `
          </>
        );
        break;

      case "not-eligible-already-aligned":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.warn}`}>!</div>
              <div>
                <h2>You recently signed up with another provider.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>Medicare's records show you joined the ACCESS program with another organization within the last 90 days. Medicare asks people to stay with their chosen provider for at least 90 days before moving.</p>
              <p>After that date you are free to move to Virdio Health.</p>
            </div>
            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={closeFlow}>
                Close
              </button>
            </div>
            {medicareTail()}
          </>
        );
        break;

      case "not-eligible-not-medicare":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.stop}`}>!</div>
              <div>
                <h2>Medicare's records show you are not eligible.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>According to Medicare, your coverage does not meet the requirements for this program — this usually relates to Part A and Part B enrollment, or to which insurance pays first.</p>
              <p>If you believe this is wrong, Medicare is the right place to check.</p>
            </div>
            {selfPayBlock(true)}
            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={() => startSelfPayGsa(kind)}>
                Show me how that works
              </button>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={closeFlow}>
                No thanks
              </button>
            </div>
            {medicareTail()}
          </>
        );
        break;

      case "not-eligible-services":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.stop}`}>!</div>
              <div>
                <h2>Medicare's records show you are not eligible.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>Medicare's records show you are receiving care that the ACCESS program cannot be combined with.</p>
              <p>If you believe this is wrong, Medicare is the right place to check.</p>
            </div>
            {clinicianBlock()}
            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={closeFlow}>
                Close
              </button>
            </div>
            {medicareTail()}
          </>
        );
        break;

      case "not-eligible-diagnoses":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.stop}`}>!</div>
              <div>
                <h2>This program did not match your records.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>The ACCESS program covers a specific list of muscle and joint conditions, and the condition we sent to Medicare is not on it.</p>
              <p>This is about the {areaLabel()} condition on file, not about your coverage.</p>
              <p>Your own doctor is the best person to talk to about this.</p>
            </div>
            {selfPayBlock(true)}
            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={() => startSelfPayGsa(kind)}>
                Show me how that works
              </button>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={closeFlow}>
                No thanks
              </button>
            </div>
            {medicareTail()}
          </>
        );
        break;

      case "not-eligible-clinical-exclusion":
        html = (
          <>
            <div className={styles.outcomeHead}>
              <div className={`${styles.oicon} ${styles.stop}`}>!</div>
              <div>
                <h2>Medicare's records show you are not eligible.</h2>
              </div>
            </div>
            <div className={styles.outcomeBody}>
              <p>Medicare has determined, from its own records, that this program is not appropriate for you at this time. Medicare makes this decision, not Virdio Health, and we are not told the reason.</p>
              <p>Your doctor, or Medicare, can tell you more.</p>
            </div>
            {clinicianBlock()}
            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={closeFlow}>
                Close
              </button>
            </div>
            {medicareTail()}
          </>
        );
        break;

      default:
        html = (
          <div className={styles.outcomeBody}>
            <p>Unexpected outcome. Please try again.</p>
          </div>
        );
    }

    setOutcomeResult(html);
  };

  // ===== PROTOTYPE CONTROLS =====

  const jumpToOutcome = () => {
    openFlow();
    renderOutcome(forceResult);
    goTo(7);
  };

  // ===== RENDER HELPERS =====

  const getCompletedFlowData = (outcomeType = forceResult) => ({
    // ===== STEP 1: AREA + STATE =====
    selectedArea,
    selectedState,

    // ===== STEP 2: MEDICARE COVERAGE =====
    screenAns,

    // ===== STEP 3: MEDICARE EXCLUSION LIST =====
    exclTicks: Array.from(exclTicks),
    exclNone,
    exclAlone,

    // ===== STEP 4: CONSENT =====
    consentChecked,
    switchConsentAttestation: switchConsentEvidence?.decision === "granted",
    switchConsentEvidence,

    // ===== STEP 5: IDENTITY =====
    firstName,
    lastName,
    dobM,
    dobD,
    dobY,
    sex,
    mbi,
    saveContact: saveContactRef.current,

    // ===== REV 4: RECORD KEEPING =====
    sessionId,
    startedAt,
    stoppedAt,
    exclusionItemsShown,
    exclusionItemsFired,
    aloneAsked,
    wordingVersion: EXCLUSION_WORDING_VERSION,
    submittedToCms: false,

    // ===== CMS ELIGIBILITY RESPONSE FIELDS =====
    submissionId,
    submissionRecordId,
    eligibilityLinkToken,

    // ===== OUTCOME =====
    outcomeType,
    isAccessUser: true,
  });
  const buildAccessDataPayload = (data) => {
    const payload = {};
    if (data.sessionId) payload.sessionId = data.sessionId;
    if (data.startedAt) payload.startedAt = data.startedAt;
    if (data.stoppedAt) payload.stoppedAt = data.stoppedAt;
    if (data.selectedArea) payload.area = data.selectedArea;
    if (data.selectedState) payload.state = data.selectedState;
    if (data.screenAns) payload.coverageAnswers = data.screenAns;
    if (data.exclusionItemsShown) payload.exclusionItemsShown = data.exclusionItemsShown;
    if (data.exclusionItemsFired) payload.exclusionItemsFired = data.exclusionItemsFired;
    if (data.exclAlone !== undefined && data.exclAlone !== null) payload.aloneAnswer = data.exclAlone;
    if (data.aloneAsked !== undefined) payload.aloneAsked = data.aloneAsked;
    if (data.outcomeType) payload.outcome = data.outcomeType;
    if (data.wordingVersion) payload.wordingVersion = data.wordingVersion;
    if (data.submittedToCms !== undefined) payload.submittedToCms = data.submittedToCms;
    if (data.submissionId) payload.submissionId = data.submissionId;
    if (data.submissionRecordId !== undefined && data.submissionRecordId !== null) {
      payload.submissionRecordId = data.submissionRecordId;
    }
    if (data.firstName) payload.legalFirstName = data.firstName;
    if (data.lastName) payload.legalLastName = data.lastName;
    if (data.dobM) payload.dobMonth = parseInt(data.dobM);
    if (data.dobD) payload.dobDay = parseInt(data.dobD);
    if (data.dobY) payload.dobYear = parseInt(data.dobY);
    if (data.sex) payload.gender = data.sex;
    if (data.mbi) payload.medicareNumber = data.mbi.replace(/[^0-9A-Z]/gi, "").toUpperCase();
    if (data.saveContact) payload.saveContact = data.saveContact;
    return payload;
  };

  const handleSwitchParticipantConsent = () => {
    const evidence = {
      decision: "granted",
      consentedAt: new Date().toISOString(),
      wordingVersion: SWITCH_CONSENT_WORDING_VERSION,
      wordingSnapshot: SWITCH_CONSENT_WORDING,
      intentToSwitch: true,
      source: "web-access-eligibility",
    };
    setSwitchConsentEvidence(evidence);
    try {
      const existing = JSON.parse(localStorage.getItem("virdio_lbp_preferences") || "{}");
      localStorage.setItem("virdio_lbp_preferences", JSON.stringify({ ...existing, switchConsentAttestation: true, switchConsentEvidence: evidence }));
    } catch (e) {
      // The completed-flow state still carries the evidence if storage is unavailable.
    }
    startAccessGsa("eligible-switch-participants", { switchConsentAttestation: true, switchConsentEvidence: evidence });
  };

  // ===== JSX =====
  const history = useHistory();
  const handleMemberLogin = () => {
    window.__suppressNativeUnloadWarning = false;
    localStorage.setItem("cameFromGsaV2", "false");
    window.loadedROM = false;
    window.clickedOnceOpen = false;
    window.movementTestPayload = null;
    window.cameraPayload = null;
    window._gsaLandingChatMovementTest = false;

    if (window.isStartedLandingFlow || window.mayraCode) {
      window.mayraCode?.setIsVisible(false);
      VoiceService.destroyMyraCompletely(false);
    }

    if (window.doKeepVideoPlay) window.doKeepVideoPlay();
    if (window.preloadAllAudios) window.preloadAllAudios();
    if (window.videoUnlockPlay) window.videoUnlockPlay();
    window.isThisFromHomeScreen = false;

    if (window.turnOffCamera) window.turnOffCamera();

    setTimeout(() => {
      if (!window.isFlutterLoaded) {
        const loader = document.getElementById("flutter-loader");
        if (loader) loader.style.display = "flex";
        const loaderText = loader?.querySelector("#loader-text");
        if (loaderText) loaderText.textContent = "Loading application...";
      }
      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";
      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";
      localStorage.removeItem("loadSelf");
      localStorage.removeItem("startedSelf");
      window.doNextLocation = history;
      document.querySelector("html").classList = [];

      if (window.isFlutterLoaded && typeof window.navigateToMemberLogin === "function") {
        window.navigateToMemberLogin();
      }

      setTimeout(() => {
        window.setHideElementsElm(true);
      }, 2000);
    }, 100);
  };

  return (
    <div className={styles.globalBody}>
      {/* Typing-indicator animation — scoped here since it isn't in the CSS module */}
      <style>{`
        @keyframes myraTypingBounce {
          0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
          30% { transform: translateY(-4px); opacity: 1; }
        }
        .myraTypingDot {
          display: inline-block;
          width: 6px;
          height: 6px;
          margin: 0 2px;
          border-radius: 50%;
          background: currentColor;
          animation: myraTypingBounce 1.2s infinite ease-in-out;
        }
        .myraTypingDot:nth-child(2) { animation-delay: 0.15s; }
        .myraTypingDot:nth-child(3) { animation-delay: 0.3s; }
      `}</style>

      {/* ===== REV 4: RETURNING-FROM-EMAIL MODAL ===== */}
      {showReturningModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: "1rem",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "14px",
              padding: "2rem",
              maxWidth: "440px",
              width: "100%",
              boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
            }}
          >
            <h3 style={{ marginTop: 0, fontSize: "22px", fontWeight: "600", color: "#0f172a" }}>Welcome back</h3>
            <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#334155", marginBottom: "24px" }}>Has anything changed since your last visit — the area bothering you, your state, or your health situation?</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={handleReturningYes} style={{ width: "100%", justifyContent: "center", padding: "14px 24px", fontSize: "16px" }}>
                Yes, something has changed
              </button>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={handleReturningNo} style={{ width: "100%", justifyContent: "center", padding: "14px 24px", fontSize: "16px" }}>
                No, nothing has changed
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== S1 IDENTITY BAR ===== */}
      <div className={styles.idbar}>
        <div className={`${styles.container} ${styles.idbarIn}`}>
          <div className={styles.logo}>
            <span className={styles.logoV}>virdio</span>
            <span className={styles.logoH}>health</span>
          </div>
          <div className={styles.creds}>
            <strong>Medicare-enrolled provider</strong>
            <span>Participant in the CMS ACCESS Model</span>
          </div>
          <a
            className={styles.memberlogin}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleMemberLogin();
            }}
          >
            Member login
          </a>
        </div>
      </div>

      {/* ===== S2 HERO ===== */}
      <div className={styles.hero}>
        <div className={styles.container}>
          <span className={styles.label}>{isGeneralAccessPage ? "Lower back, hip, thigh, and knee" : "Lower back pain"}</span>
          <h1>{isGeneralAccessPage ? "Physical therapy for your muscle and joint pain, at home, covered by Medicare." : "Physical therapy for lower back pain, at home, covered by Medicare."}</h1>
          <p>Medicare is testing a new way to pay for physical therapy you do at home. Virdio Health is one of the providers taking part. If you have Original Medicare — Part A and Part B — you may qualify. If you do, it costs you nothing.</p>
          <div className={styles.heroCta}>
            <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={openFlow}>
              Check if I qualify
            </button>
            <span className={styles.ctaMicro}>A few short questions. You get your answer right away.</span>
          </div>
        </div>
      </div>

      {/* ===== S3 MEDICARE PROGRAM + COST ===== */}
      <section className={styles.program}>
        <div className={styles.container}>
          <span className={styles.label}>About the program</span>
          <h2>A real Medicare program. Not a subscription.</h2>

          <p>ACCESS stands for Advancing Chronic Care with Effective, Scalable Solutions. It is a payment model created by the Centers for Medicare and Medicaid Services to pay for care delivered at home using technology.</p>

          <p>Virdio Health was accepted into the CMS ACCESS Model through a formal application process that includes a licensed medical director, credentialed physical therapists, and CMS integration testing. As an approved participating provider, Medicare pays us directly for your care, the same way it pays a clinic or a hospital.</p>

          <p>
            You can read about the program on Medicare's own website at
            <a href="https://www.medicare.gov/access" target="_blank" rel="noopener noreferrer">
              <strong> Medicare.gov/ACCESS</strong>
            </a>
            , and you can find Virdio Health on the
            <a href="https://www.cms.gov/priorities/innovation/access-model-accepted-applicants" target="_blank" rel="noopener noreferrer">
              <strong> CMS list of accepted ACCESS participants</strong>
            </a>
            .
          </p>

          <div className={styles.costcard}>
            <h3>What it costs you</h3>
            <p className={styles.big}>
              <strong>Nothing.</strong> Medicare pays Virdio Health directly, and Virdio Health covers the share you would normally owe.
            </p>
            <ul>
              <li>
                <strong>No copay and no deductible.</strong> You will not be billed for this program.
              </li>
              <li>
                <strong>Nothing to buy.</strong> No subscription, no equipment to purchase, nothing to cancel.
              </li>
              <li>
                <strong>Nothing to owe afterwards.</strong> There is no bill at the end.
              </li>
              <li>
                <strong>Your Medicare does not change.</strong> Taking part does not affect your Medicare benefits, your rights, or your coverage. You can still see any Medicare provider you choose.
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* ===== S4 MEET MYRA ===== */}
      <section className={styles.myra}>
        <div className={styles.container}>
          <span className={styles.label}>Who guides your care</span>
          <h2>Meet Myra, your recovery coach.</h2>

          <p>Myra is an AI recovery coach built on physical therapy principles and developed with clinical guidance from licensed Doctors of Physical Therapy.</p>

          <p>She asks about your {isGeneralAccessPage ? "problem area" : "lower back"}, walks you through a short movement check, and builds a plan of gentle stretches and exercises made for you. Your assessment takes about 15 minutes, and you will see exactly which stretches to start with right away.</p>

          <p>From there, Myra leads every session and adjusts as you improve. If a session ever feels too easy or too hard, just tell her. You can talk to Myra anytime during your recovery, and she will adjust on the spot.</p>

          <p>Licensed clinicians work behind the scenes. They set and review the safety protocols Myra follows, and Virdio Health maintains licensed physical therapists in every region it serves to support your care.</p>

          <p>If anything suggests this program is not the right fit for you, Myra will tell you plainly and recommend you see a provider in person.</p>

          <div className={styles.myraNote}>
            <strong>To be clear:</strong> Myra is an AI recovery coach. She is not a doctor, a nurse, or a physical therapist. As part of the program, Virdio Health records the condition being treated so it can be billed to Medicare. If you ask us to keep your regular doctor informed, we share that along with your progress.
          </div>
        </div>
      </section>

      {/* ===== S5 HOW IT WORKS ===== */}
      <section className={styles.section}>
        <div className={styles.container}>
          <span className={styles.label}>What to expect</span>
          <h2>How this works.</h2>
          <span className={styles.duration}>The program runs for 12 months</span>

          <div className={styles.steps5}>
            <div className={styles.s5}>
              <div className={styles.s5N}>1</div>
              <div>
                <h4>Tell us where you live, then check if you qualify</h4>
                <p>First, we will ask which state you live in so we can confirm we have licensed physical therapists serving your area. Then you will answer a few short questions, and we check your eligibility with Medicare in real time. Most answers come back in under a minute — you will see a progress indicator while we wait.</p>
              </div>
            </div>
            <div className={styles.s5}>
              <div className={styles.s5N}>2</div>
              <div>
                <h4>Once Medicare confirms you qualify, meet Myra</h4>
                <p>Myra will ask about your {isGeneralAccessPage ? "problem area" : "lower back"} and guide you through one gentle movement. The assessment takes about 15 minutes, and you will see exactly which stretches to start with right away.</p>
              </div>
            </div>
            <div className={styles.s5}>
              <div className={styles.s5N}>3</div>
              <div>
                <h4>Short sessions at home</h4>
                <p>Myra leads you through your stretches and exercises. Sessions take 10 to 20 minutes.</p>
              </div>
            </div>
            <div className={styles.s5}>
              <div className={styles.s5N}>4</div>
              <div>
                <h4>Questions every 90 days</h4>
                <p>Roughly every 90 days, Myra asks you a short set of questions about your pain and what you can do day to day. Virdio Health reports those answers to Medicare. That is how Medicare sees whether the program is working.</p>
              </div>
            </div>
            <div className={styles.s5}>
              <div className={styles.s5N}>5</div>
              <div>
                <h4>Talk to Myra anytime</h4>
                <p>If a session ever feels too easy or too hard, just tell Myra and she will adjust right away. You do not have to wait. And because Medicare holds back part of what it pays us until it sees whether the people we treat actually improve, your results genuinely matter to us.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== S6 WHAT WE WILL ASK FOR ===== */}
      <section className={styles.ask}>
        <div className={styles.container}>
          <span className={styles.label}>Before you begin</span>
          <h2>What we will ask for, and what we never will.</h2>

          <div className={styles.askGrid}>
            <div>
              <div className={styles.statebox}>
                <p>
                  First we will ask <b>which state you live in</b>, so we can confirm we have a physical therapist licensed to treat you where you live. You can check that right now.
                </p>
                <div className={styles.statepick}>
                  <select className={styles.input} value={lpStateChoice} onChange={handleLpStateChange}>
                    <option value="">Select your state</option>
                    {STATES.filter(([ab]) => SERVED_STATES.includes(ab)).map(([ab, nm]) => (
                      <option key={ab} value={ab}>
                        {nm}
                      </option>
                    ))}
                    <option value="__other">My state is not listed</option>
                  </select>
                </div>
                {lpStateAck.show && <div className={`${styles.stateack} ${lpStateAck.good ? styles.good : styles.bad}`}>{lpStateAck.text}</div>}

                <div className={styles.areacheck}>
                  <p className={styles.arealabel}>Problem areas we currently work with</p>
                  <div className={styles.arearow}>
                    {AREA_ORDER.map((code) => (
                      <button key={code} type="button" className={`${styles.areachip} ${lpAreaChoice === code ? styles.sel : ""}`} onClick={() => handleLpAreaPick(code)}>
                        {AREA_LABELS[code].charAt(0).toUpperCase() + AREA_LABELS[code].slice(1)}
                      </button>
                    ))}
                  </div>
                  <p className={styles.areanote}>Every state we serve covers all four. Pick the one that fits you and we will carry it through.</p>
                </div>
              </div>

              <p>After that, Medicare decides who qualifies, not us. To check on your behalf, Medicare needs four things:</p>

              <ul className={styles.askList}>
                <li>
                  <b>Your legal name</b>
                  <span>As it appears on your Medicare card</span>
                </li>
                <li>
                  <b>Your date of birth</b>
                  <span>This is not printed on your Medicare card. Medicare keeps it in its own records, and what we send has to match.</span>
                </li>
                <li>
                  <b>Your sex, as Medicare has it on record</b>
                  <span>Also not printed on your card, and also kept in Medicare's own records.</span>
                </li>
                <li>
                  <b>Your Medicare number</b>
                  <span>The 11-character number on the front of your red, white, and blue card</span>
                </li>
              </ul>

              <p className={styles.closer}>That is everything. Nothing else is asked for at any point.</p>
            </div>

            <figure className={styles.cardfig}>
              <svg viewBox="0 0 400 232" width="100%" role="img" aria-label="Illustration showing where the 11-character Medicare number appears on a Medicare card">
                <rect x="6" y="6" width="388" height="220" rx="14" fill="#ffffff" stroke="#cbd5e1" strokeWidth="2" />
                <rect x="6" y="6" width="388" height="30" rx="14" fill="#e2e8f0" />
                <rect x="6" y="26" width="388" height="10" fill="#e2e8f0" />
                <rect x="26" y="16" width="120" height="10" rx="5" fill="#94a3b8" />
                <rect x="26" y="58" width="70" height="9" rx="4.5" fill="#cbd5e1" />
                <rect x="26" y="76" width="150" height="13" rx="6" fill="#94a3b8" />
                <rect x="26" y="112" width="130" height="9" rx="4.5" fill="#cbd5e1" />
                <rect x="20" y="128" width="250" height="44" rx="8" fill="#e6f7f6" stroke="#0d9488" strokeWidth="2.5" />
                <text x="34" y="158" fontFamily="ui-monospace, Menlo, monospace" fontSize="23" letterSpacing="2.5" fill="#0f172a" fontWeight="700">
                  1EG4-TE5-MK73
                </text>
                <text x="286" y="152" fontFamily="DM Sans, sans-serif" fontSize="13" fill="#0d9488" fontWeight="700">
                  This one
                </text>
                <path d="M282 147 L272 150" stroke="#0d9488" strokeWidth="2.5" strokeLinecap="round" />
                <rect x="26" y="190" width="90" height="9" rx="4.5" fill="#cbd5e1" />
                <rect x="130" y="190" width="90" height="9" rx="4.5" fill="#cbd5e1" />
              </svg>
              <figcaption>
                Your Medicare number is 11 characters, made up of numbers and capital letters. The dashes on the card are only there to make it easier to read. You can type it with or without them.
                <br />
                <br />
                <span className={styles.ph}>Illustration only — not a reproduction of the Medicare card</span>
              </figcaption>
            </figure>
          </div>

          <div className={styles.never}>
            <h3>What we will never ask for</h3>
            <ul>
              <li>We will never ask for a credit card.</li>
              <li>We will never ask for your bank account.</li>
              <li>We will never ask for your Social Security number.</li>
              <li>We will never ask for a payment of any kind.</li>
            </ul>
            <p>Checking whether you qualify is free, and if you qualify the Medicare program costs you nothing — there is nothing to buy and nothing to cancel. If you do not qualify, we will tell you plainly and show you what else is available. Nothing is ever charged unless you choose it first. If anyone claiming to be from Virdio Health asks you for money or payment details to check your eligibility, it is not us.</p>
          </div>
        </div>
      </section>

      {/* ===== S7 CTA ===== */}
      <section className={styles.ctaband}>
        <div className={styles.container}>
          <h2>Find out if you qualify.</h2>
          <p className={styles.narrow}>You will get an answer before you commit to anything. If you do not qualify, we will tell you plainly, and if there is another option we will point you to it.</p>
          <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={openFlow}>
            Check if I qualify
          </button>
          <span className={styles.ctaMicro}>A few short questions.</span>
        </div>
      </section>

      {/* ===== S8 QUESTIONS / MYRA CHAT ===== */}
      <section className={styles.qsection}>
        <div className={styles.container}>
          <span className={styles.label}>If you get stuck</span>
          <h2>Questions along the way? Just ask.</h2>
          <p>Myra is with you the whole way, on this page and every step after it. Try her now — ask anything about the program and she will explain it as plainly as she can.</p>

          <div className={styles.chat}>
            <div className={styles.chatHead}>
              <div className={styles.chatDot}>M</div>
              <div>
                <b>Myra</b> <span>· AI recovery coach</span>
              </div>
            </div>
            <div className={styles.chatLog} ref={chatLogRef}>
              {chatMessages.map((msg, idx) => (
                <div key={idx} className={`${styles.msg} ${msg.who === "u" ? styles.u : styles.m}`}>
                  {msg.text}
                </div>
              ))}
              {landingTyping && (
                <div className={`${styles.msg} ${styles.m}`} aria-live="polite" aria-label="Myra is typing">
                  <span className="myraTypingDot" />
                  <span className="myraTypingDot" />
                  <span className="myraTypingDot" />
                </div>
              )}
            </div>
            <div className={styles.chips}>
              <button className={styles.chip} onClick={() => askMyra("How does this work?")}>
                How does this work?
              </button>
              <button className={styles.chip} onClick={() => askMyra("What is the ACCESS Model?")}>
                What is the ACCESS Model?
              </button>
              <button className={styles.chip} onClick={() => askMyra("Why do you need my Medicare number?")}>
                Why do you need my Medicare number?
              </button>
              <button className={styles.chip} onClick={() => askMyra("Is this really free?")}>
                Is this really free?
              </button>
              <button className={styles.chip} onClick={() => askMyra("Can I start now?")}>
                Can I start now?
              </button>
            </div>
            <div className={styles.chatIn}>
              <input
                type="text"
                className={styles.input}
                placeholder="Type your question here"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") sendChat();
                }}
              />
              <button onClick={sendChat}>Send</button>
            </div>
          </div>

          <div className={styles.medbox}>
            <h3>Questions about your Medicare records or coverage</h3>
            <p>Medicare is the right place to ask.</p>
            <p>
              <strong>1-800-MEDICARE (1-800-633-4227)</strong>
              <br />
              TTY users can call <strong>1-877-486-2048</strong>
            </p>
            <p>
              You can also read about the ACCESS Model on Medicare's own website at
              <a href="https://www.medicare.gov/access" target="_blank" rel="noopener noreferrer">
                <strong> Medicare.gov/ACCESS</strong>
              </a>
              , and find Virdio Health on the
              <a href="https://www.cms.gov/priorities/innovation/access-model-accepted-applicants" target="_blank" rel="noopener noreferrer">
                <strong> CMS list of accepted ACCESS participants</strong>
              </a>
              .
            </p>
          </div>
        </div>
      </section>

      {/* ===== S9 FOOTER ===== */}
      <footer className={styles.footer}>
        <div className={styles.container}>
          <div className={styles.disclaimer}>
            <p>Virdio Health applied to the CMS ACCESS Model and was approved by the Centers for Medicare and Medicaid Services to participate as an ACCESS Participant. Approval to participate is not an endorsement of Virdio Health, or of any service it provides, by CMS or any other government agency.</p>
            <p>Myra guides your recovery experience using information you share with her. She is an AI recovery coach and is not a substitute for medical advice, diagnosis, or treatment from your doctor. Information gathered through the program may be used for care coordination and to report your progress to Medicare as required by the ACCESS Model.</p>
          </div>
          <div className={styles.footlinks}>
            <a rel="noopener noreferrer" target="_blank" href="/privacy">
              Privacy Policy
            </a>
            <a rel="noopener noreferrer" href="#">
              Notice of Privacy Practices
            </a>
            <a rel="noopener noreferrer" target="_blank" href="/terms">
              Terms of Use
            </a>
            <a rel="noopener noreferrer" href="/contact-us">
              Contact
            </a>
            <a href="https://www.virdiohealth.com" target="_blank" rel="noopener noreferrer">
              virdiohealth.com
            </a>
          </div>
          <div className={styles.copy}>© 2026 Virdio Health. All rights reserved.</div>
        </div>
      </footer>

      {/* ===== ELIGIBILITY FLOW ===== */}
      <div ref={flowRef} className={`${styles.flow} ${flowOpen ? styles.flowOn : ""}`}>
        <div className={styles.flowBar}>
          <div className={`${styles.container} ${styles.flowBarIn}`}>
            <div className={styles.logo}>
              <span className={styles.logoV}>virdio</span>
              <span className={styles.logoH}>health</span>
            </div>
            <button className={styles.flowExit} onClick={closeFlow}>
              Leave
            </button>
          </div>
        </div>

        <div className={`${styles.container} ${styles.narrow}`}>
          <div className={styles.progress}>
            <div className={styles.progressTrack}>
              <div className={styles.progressFill} style={{ width: step === 8 ? `${(4 / TOTAL) * 100}%` : step === 7 ? "100%" : step === 6 ? `${(2 / TOTAL) * 100}%` : `${(step / TOTAL) * 100}%` }} />{" "}
            </div>
            <div className={styles.progressText}>{step === 8 ? "Your care team" : step === 7 ? "Your result" : step === 6 ? "Checking..." : `Step ${step} of ${TOTAL}`}</div>
          </div>

          {/* STEP 1 — STATE + AREA */}
          <div className={`${styles.pane} ${step === 1 ? styles.paneOn : ""}`}>
            <h2>First, two quick things.</h2>
            <div className={styles.why}>We ask these before anything else because a physical therapist has to be licensed in your state to treat you, and because the questions that follow depend on which area is bothering you. If we cannot help, we will tell you now rather than after you have given us anything else.</div>

            <div className={styles.qcard}>
              <div className={styles.qnum}>Question 1 of 2</div>
              <p>Which area is bothering you?</p>
              <div className={styles.qsub}>If more than one hurts, choose the one that troubles you most.</div>
              <div className={styles.opts}>
                {AREA_ORDER.map((code) => (
                  <button key={code} type="button" className={`${styles.opt} ${selectedArea === code ? styles.sel : ""} ${areaErr ? styles.inputErr : ""}`} onClick={() => handleAreaPick(code)}>
                    {AREA_LABELS[code].charAt(0).toUpperCase() + AREA_LABELS[code].slice(1)}
                  </button>
                ))}
              </div>
            </div>

            <div className={styles.qcard}>
              <div className={styles.qnum}>Question 2 of 2</div>
              <p>Which state do you live in?</p>
              <select className={`${styles.input} ${stateErr ? styles.inputErr : ""}`} value={selectedState} onChange={(e) => handleStatePick(e.target.value)}>
                <option value="">Select your state</option>
                {STATES.filter(([ab]) => SERVED_STATES.includes(ab)).map(([ab, nm]) => (
                  <option key={ab} value={ab}>
                    {nm}
                  </option>
                ))}
                <option value="__other">My state is not listed</option>
              </select>
            </div>

            {(areaErr || stateErr) && (
              <div className={`${styles.errmsg} ${styles.errmsgOn}`}>
                {areaErr && <div>{areaErr}</div>}
                {stateErr && <div>{stateErr}</div>}
              </div>
            )}

            <div className={`${styles.actions} ${myraPanelOpen ? styles.actionsMyraPanelOpen : ""}`}>
              <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={submitState}>
                Continue
              </button>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={closeFlow}>
                Cancel
              </button>
            </div>
          </div>

          {/* STEP 2 — IDENTITY (REV 5: moved ahead of coverage so Medicare answers first) */}
          <div className={`${styles.pane} ${step === 2 ? styles.paneOn : ""}`}>
            <h2>Now we need to look you up with Medicare.</h2>
            <div className={styles.why}>Medicare needs all four of these to match you to its records.</div>

            <div className={styles.namerow}>
              <div className={styles.fieldrow}>
                <label className={styles.fl} htmlFor="first">
                  Legal first name
                </label>
                <input type="text" id="first" className={`${styles.input} ${idErr && !firstName.trim() ? styles.inputErr : ""}`} value={firstName} onChange={(e) => setFirstName(e.target.value)} autoComplete="given-name" />
              </div>
              <div className={styles.fieldrow}>
                <label className={styles.fl} htmlFor="last">
                  Legal last name
                </label>
                <input type="text" id="last" className={`${styles.input} ${idErr && !lastName.trim() ? styles.inputErr : ""}`} value={lastName} onChange={(e) => setLastName(e.target.value)} autoComplete="family-name" />
              </div>
            </div>
            <div className={styles.hint} style={{ marginTop: "-0.6rem", marginBottom: "1.1rem" }}>
              Both as they appear on your Medicare card.
            </div>

            <div className={styles.fieldrow}>
              <label className={styles.fl}>Date of birth</label>
              <div className={styles.hint}>This is not printed on your Medicare card. Medicare keeps it in its own records, and what we send has to match.</div>
              <div className={styles.dobRow}>
                <select className={`${styles.input} ${idErr && !dobM.trim() ? styles.inputErr : ""}`} value={dobM} onChange={(e) => setDobM(e.target.value)}>
                  <option value="">Month</option>
                  {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((nm, i) => (
                    <option key={i + 1} value={i + 1}>
                      {nm}
                    </option>
                  ))}
                </select>
                <select className={`${styles.input} ${idErr && !dobD.trim() ? styles.inputErr : ""}`} value={dobD} onChange={(e) => setDobD(e.target.value)}>
                  <option value="">Day</option>
                  {Array.from({ length: 31 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>
                <select className={`${styles.input} ${idErr && !dobY.trim() ? styles.inputErr : ""}`} value={dobY} onChange={(e) => setDobY(e.target.value)}>
                  <option value="">Year</option>
                  {(() => {
                    const now = new Date().getFullYear();
                    const years = [];
                    for (let i = now - 18; i >= now - 110; i--) {
                      years.push(i);
                    }
                    return years.map((y) => (
                      <option key={y} value={y}>
                        {y}
                      </option>
                    ));
                  })()}
                </select>
              </div>
            </div>

            <div className={styles.fieldrow}>
              <label className={styles.fl} htmlFor="sex">
                Sex, as Medicare has it on record
              </label>
              <div className={styles.hint}>Also not printed on your card, and also kept in Medicare's own records.</div>
              <select id="sex" className={`${styles.input} ${idErr && !sex.trim() ? styles.inputErr : ""}`} value={sex} onChange={(e) => setSex(e.target.value)}>
                <option value="">Select</option>
                <option value="female">Female</option>
                <option value="male">Male</option>
                <option value="other">Other</option>
                <option value="unknown">Not sure</option>
              </select>
            </div>

            <div className={styles.fieldrow}>
              <label className={styles.fl} htmlFor="mbi">
                Medicare number
              </label>
              <div className={styles.hint}>11 characters, from the front of your red, white and blue card. Type it with or without dashes — we will format it for you. Lower case is fine.</div>
              <input ref={mbiRef} type="text" id="mbi" className={`${styles.input} ${styles.mbiInput} ${(idErr && !mbi.trim()) || isMbiInvalid ? styles.inputErr : ""}`} placeholder="1EG4-TE5-MK73" maxLength="13" value={mbi} onChange={handleMbiChange} inputMode="text" autoComplete="off" spellCheck="false" />
              {idErr && (
                <div className={`${styles.errmsg} ${styles.errmsgOn}`}>
                  {idErr.split("\n").map((line, i) => (
                    <div key={i}>{line}</div>
                  ))}
                </div>
              )}
            </div>

            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={submitIdentity}>
                Check with Medicare
              </button>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={() => goTo(1)}>
                Go back
              </button>
            </div>
            <div className={styles.helpline}>
              Can't find your card? Call <a href="tel:18006334227">1-800-MEDICARE</a> (1-800-633-4227) or sign in at Medicare.gov to get your number, then come back.
            </div>
          </div>

          {/* STEP 3 — MEDICARE COVERAGE (REV 4: COVERAGE ONLY. REV 5: now shown after the Medicare check) */}
          <div className={`${styles.pane} ${step === 3 ? styles.paneOn : ""}`}>
            <h2>First, your Medicare coverage.</h2>
            <div className={styles.why}>Medicare only allows people with certain kinds of coverage to take part in this program. Answering these now means you find out before you give us any personal information.</div>

            {/* Question 1: Card type */}
            <div
              ref={(el) => {
                screenQRefs.current.card = el;
              }}
              className={`${styles.qcard} ${screenErr && !screenAns.card ? styles.miss : ""}`}
            >
              <div className={styles.qnum}>Question 1 of 3</div>
              <p>Which card do you show at the doctor's office?</p>
              <div className={styles.qsub}>Original Medicare uses the red, white, and blue card issued by the government. Medicare Advantage plans issue their own card instead.</div>
              <div className={`${styles.opts} ${styles.wide}`}>
                <button type="button" className={`${styles.opt} ${screenAns.card === "original" ? styles.sel : ""}`} onClick={() => handleAns("card", "original")}>
                  My red, white, and blue Medicare card
                </button>
                <button type="button" className={`${styles.opt} ${screenAns.card === "ma" ? styles.sel : ""}`} onClick={() => handleAns("card", "ma")}>
                  A card from a private plan — Aetna, Humana, UnitedHealthcare, and so on
                </button>
                <button type="button" className={`${styles.opt} ${screenAns.card === "unsure" ? styles.sel : ""}`} onClick={() => handleAns("card", "unsure")}>
                  I'm not sure
                </button>
              </div>
            </div>

            {/* Question 2: Primary insurance */}
            <div
              ref={(el) => {
                screenQRefs.current.primary = el;
              }}
              className={`${styles.qcard} ${screenErr && !screenAns.primary ? styles.miss : ""}`}
            >
              <div className={styles.qnum}>Question 2 of 3</div>
              <p>Do you have Medicaid, or another insurance that pays before Medicare does?</p>
              <div className={styles.opts}>
                <button type="button" className={`${styles.opt} ${screenAns.primary === "yes" ? styles.sel : ""}`} onClick={() => handleAns("primary", "yes")}>
                  Yes
                </button>
                <button type="button" className={`${styles.opt} ${screenAns.primary === "no" ? styles.sel : ""}`} onClick={() => handleAns("primary", "no")}>
                  No
                </button>
                <button type="button" className={`${styles.opt} ${screenAns.primary === "unsure" ? styles.sel : ""}`} onClick={() => handleAns("primary", "unsure")}>
                  I'm not sure
                </button>
              </div>
            </div>

            {/* Question 3: Services (REV 4: hospice removed, moved to Step 3) */}
            <div
              ref={(el) => {
                screenQRefs.current.services = el;
              }}
              className={`${styles.qcard} ${screenErr && !screenAns.services ? styles.miss : ""}`}
            >
              <div className={styles.qnum}>Question 3 of 3</div>
              <p>Are you currently receiving dialysis for kidney failure, or care through a PACE program?</p>
              <div className={styles.qsub}>PACE stands for Programs of All-Inclusive Care for the Elderly.</div>
              <div className={styles.opts}>
                <button type="button" className={`${styles.opt} ${screenAns.services === "yes" ? styles.sel : ""}`} onClick={() => handleAns("services", "yes")}>
                  Yes
                </button>
                <button type="button" className={`${styles.opt} ${screenAns.services === "no" ? styles.sel : ""}`} onClick={() => handleAns("services", "no")}>
                  No
                </button>
                <button type="button" className={`${styles.opt} ${screenAns.services === "unsure" ? styles.sel : ""}`} onClick={() => handleAns("services", "unsure")}>
                  I'm not sure
                </button>
              </div>
            </div>

            {screenErr && <div className={`${styles.errmsg} ${styles.errmsgOn}`}>{screenErr}</div>}

            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={submitScreen}>
                Continue
              </button>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={() => goTo(2)}>
                Go back
              </button>
            </div>
            <div className={styles.helpline}>Not sure about an answer? Choose "I'm not sure" and we will check it with Medicare for you.</div>
          </div>

          {/* STEP 4 — MEDICARE EXCLUSION LIST (REV 4: NEW) */}
          <div className={`${styles.pane} ${step === 4 ? styles.paneOn : ""}`}>
            <h2>Before we go on, Medicare asks us to check a few things.</h2>
            <div className={styles.why}>There are some situations where Medicare does not allow someone to take part in the ACCESS program. We need to ask about them first so we can give you the right answer.</div>

            <div className={`${styles.qcard} ${exclListMiss ? styles.miss : ""}`}>
              <div className={styles.qnum}>Question 1 of 2</div>
              <p>Do any of these apply to you right now?</p>
              <div className={styles.qsub}>Tick every one that applies. If none of them do, tick the last option.</div>
              <div id="exclList">
                {getExclusionItems(selectedArea).map((item) => (
                  <div key={item.id} className={`${styles.check} ${exclTicks.has(item.id) ? styles.sel : ""}`} onClick={() => toggleExcl(item.id)}>
                    <span className={styles.box} />
                    <span>{item.text}</span>
                  </div>
                ))}
              </div>
              <div className={styles.checkdiv}>Or</div>
              <div className={`${styles.check} ${exclNone ? styles.sel : ""}`} onClick={() => toggleExcl("none")}>
                <span className={styles.box} />
                <span>None of these apply to me</span>
              </div>
            </div>

            {/* Alone question - only shown when "None" is selected */}
            <div ref={exclAloneRef} className={`${styles.qcard} ${!exclNone ? styles.hide : ""} ${exclAloneMiss ? styles.miss : ""}`}>
              <div className={styles.qnum}>Question 2 of 2</div>
              <p>Are you able to do gentle exercises safely at home on your own, without another person there to help you?</p>
              <div className={styles.qsub}>This is a program you follow at home on your own, so Medicare asks us to check.</div>
              <div className={styles.opts}>
                <button type="button" className={`${styles.opt} ${exclAlone === "yes" ? styles.sel : ""}`} onClick={() => handleExclAlone("yes")}>
                  Yes
                </button>
                <button type="button" className={`${styles.opt} ${exclAlone === "no" ? styles.sel : ""}`} onClick={() => handleExclAlone("no")}>
                  No
                </button>
              </div>
            </div>

            {screenErr && <div className={`${styles.errmsg} ${styles.errmsgOn}`}>{screenErr}</div>}

            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={submitExcl}>
                Continue
              </button>
              <button
                className={`${styles.btn} ${styles.btnGhost}`}
                onClick={() => {
                  goTo(3);
                  setScreenErr("");
                }}
              >
                Go back
              </button>
            </div>
            <div className={styles.helpline}>These are Medicare's rules for the program, not a medical assessment. If you are unsure about one of them, your doctor's office can tell you. Answer as accurately as you can.</div>
            {/* <div className={styles.helpline}>Wording version: {EXCLUSION_WORDING_VERSION}</div> */}
          </div>

          {/* STEP 5 — DISCLOSURE + CONSENT (REV 5: last screen before the outcome) */}
          <div className={`${styles.pane} ${step === 5 ? styles.paneOn : ""}`}>
            <h2>Before we check with Medicare.</h2>
            <div className={styles.why}>Medicare requires us to tell you these things before we look you up. Please read them.</div>

            <div className={styles.disclosure}>
              <h3>
                Notice about taking part in a CMS payment model
                <span className={styles.ph}> Pending legal review against CMS Block 1</span>
              </h3>
              <p>The services Virdio Health offers are part of a new federal payment model test run by the Centers for Medicare and Medicaid Services, called the Advancing Chronic Care with Effective, Scalable Solutions (ACCESS) Model. By continuing, you confirm you have been told the following.</p>

              <h3>Data sharing</h3>
              <ul>
                <li>Virdio Health may share your health information with Medicare.</li>
                <li>Medicare may also access or request your health information, including through health information exchanges or other sources, as part of evaluating the program.</li>
                <li>Federal privacy and security protections apply to anything shared.</li>
              </ul>

              <h3>Control group assignment</h3>
              <ul>
                <li>You may be randomly assigned to a control group. If that happens, you cannot enroll in ACCESS with any participating provider for 12 months, unless Medicare says otherwise.</li>
                <li>Being assigned to the control group does not otherwise affect your Medicare benefits, your rights, or your coverage.</li>
              </ul>
            </div>

            <label className={`${styles.consent} ${consentMiss ? styles.miss : ""}`}>
              <input
                type="checkbox"
                checked={consentChecked}
                onChange={(e) => {
                  setConsentChecked(e.target.checked);
                  if (e.target.checked) {
                    setConsentMiss(false);
                    setConsentErr("");
                  }
                }}
              />
              <span>I have read the information above and I want Virdio Health to check whether I qualify.</span>
            </label>

            {consentErr && <div className={`${styles.errmsg} ${styles.errmsgOn}`}>{consentErr}</div>}

            <div className={styles.actions}>
              <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={submitConsent}>
                I understand — continue
              </button>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={() => goTo(4)}>
                Go back
              </button>
            </div>
          </div>

          {/* STEP 8 — CARE TEAM INTAKE (not currently in the main path) */}
          <div className={`${styles.pane} ${step === 8 ? styles.paneOn : ""}`}>
            {/* <CareTeamIntake firstName={firstName} lastName={lastName} selectedState={selectedState} submissionId={submissionId} submissionRecordId={submissionRecordId} onContinue={() => goTo(5)} /> */}
            <CareTeamIntake
              selectedState={selectedState}
              sessionId={sessionId}
              onAnalyticsEvent={(event, value) => recordAccessAnalyticsEvent("access_care_team", event, value)}
              onContinue={(careTeamOutcome) => {
                exitAccessAnalyticsScreen("access_care_team", {
                  access_care_team_completed: true,
                  access_care_team_outcome: careTeamOutcome || "completed",
                });
                goTo(2);
              }}
            />
          </div>

          {/* STEP 6 — WAITING */}
          <div className={`${styles.pane} ${step === 6 ? styles.paneOn : ""}`}>
            <div className={styles.waiting}>
              <div className={styles.spinner} />
              <h2>Checking with Medicare…</h2>
              <p className={styles.narrow}>This usually takes less than a minute. Please do not close this window or press the back button.</p>
              <p className={styles.narrow} style={{ color: "var(--gray500)" }}>
                We are asking Medicare's system whether you qualify for the ACCESS program. We will show you the answer here as soon as it comes back.
              </p>
            </div>
          </div>

          {/* STEP 7 — OUTCOME */}
          <div className={`${styles.pane} ${step === 7 ? styles.paneOn : ""}`}>
            <div id="outcomeSlot">{outcomeResult}</div>
          </div>
        </div>
      </div>

      {/* ===== ITEM 28: Myra pinned to the bottom of the flow ===== */}
      <div className={`${styles.myrabar} ${flowOpen ? styles.flowOn : ""}`}>
        <div className={styles.myrabarIn}>
          {myraPanelOpen && (
            <button className={styles.myraClose} onClick={() => setMyraPanelOpen(false)} aria-label="Minimize chat">
              ✕
            </button>
          )}
          <div className={`${styles.myrapanel} ${myraPanelOpen ? styles.on : ""}`}>
            <div className={styles.myralabel}>Myra · AI recovery coach</div>
            <div className={styles.myraLog} ref={myraLogRef}>
              {myraMessages.map((msg, idx) => (
                <div key={idx} className={`${styles.msg} ${msg.who === "u" ? styles.u : styles.m}`}>
                  {msg.text}
                </div>
              ))}
              {flowTyping && (
                <div className={`${styles.msg} ${styles.m}`} aria-live="polite" aria-label="Myra is typing">
                  <span className="myraTypingDot" />
                  <span className="myraTypingDot" />
                  <span className="myraTypingDot" />
                </div>
              )}
            </div>
            <div className={styles.myrachips}>
              <button className={styles.chip} onClick={() => askMyraFlow("Why do you need my Medicare number?")}>
                Why do you need my Medicare number?
              </button>
              <button className={styles.chip} onClick={() => askMyraFlow("What happens next?")}>
                What happens next?
              </button>
              <button className={styles.chip} onClick={() => askMyraFlow("Is this really free?")}>
                Is this really free?
              </button>
            </div>
          </div>
          <div className={styles.myrarow}>
            <div className={styles.myraavatar}>M</div>
            <input
              type="text"
              className={styles.input}
              placeholder="Ask Myra a question"
              value={myraInput}
              onChange={(e) => setMyraInput(e.target.value)}
              onFocus={() => setMyraPanelOpen(true)}
              onKeyDown={(e) => {
                if (e.key === "Enter") sendMyraFlow();
              }}
            />
            <button className={styles.myrasend} onClick={sendMyraFlow} aria-label="Send">
              ↑
            </button>
          </div>
        </div>
      </div>

      {/* ===== PROTOTYPE CONTROLS (commented out for production) ===== */}
      {/* <div className={styles.protobar}>
        <b>Prototype</b>
        <span className={styles.ver}>Rev 4</span>
        <span>Eligibility result:</span>
        <select value={forceResult} onChange={(e) => setForceResult(e.target.value)}>
          <option value="eligible">eligible</option>
          <option value="eligible-pending-diagnosis">eligible-pending-diagnosis</option>
          <option value="eligible-switch-participants">eligible-switch-participants</option>
          <option value="not-eligible-mismatch">not-eligible-mismatch</option>
          <option value="not-eligible-control-group">not-eligible-control-group</option>
          <option value="not-eligible-not-medicare">not-eligible-not-medicare</option>
          <option value="not-eligible-services">not-eligible-services</option>
          <option value="not-eligible-diagnoses">not-eligible-diagnoses</option>
          <option value="not-eligible-already-aligned">not-eligible-already-aligned</option>
          <option value="state-not-served">state-not-served</option>
          <option value="not-eligible-clinical-exclusion">not-eligible-clinical-exclusion</option>
          <option value="excl-supervised">excl-supervised (Rev 4)</option>
          <option value="excl-pregnancy">excl-pregnancy (Rev 4)</option>
          <option value="excl-hospice">excl-hospice (Rev 4)</option>
          <option value="prescreen-services">prescreen-services</option>
          <option value="prescreen-ma">prescreen-ma</option>
          <option value="prescreen-not-primary">prescreen-not-primary</option>
        </select>
        <button onClick={openFlow}>Open flow</button>
        <button onClick={jumpToOutcome}>Jump to result</button>
        <button onClick={closeFlow}>Back to page</button>
        <span style={{ color: "#888" }}>Amber tags = copy not final</span>
      </div> */}
    </div>
  );
};

export default LbpNewLandingPage;
